/* Türkçe — Turkish */
const tr = {
  nav: {
    home: 'Ana Sayfa',
    imageConverter: 'Görüntü Dönüştürücü',
    imageCompressor: 'Görüntü Sıkıştırıcı',
    otherTools: 'Diğer Araçlar',
    resizeImage: 'Görüntü Boyutlandır',
    cropImage: 'Görüntü Kırp',
    photoEditor: 'Fotoğraf Editörü',
    removeBackground: 'Arka Planı Kaldır',
    watermarkImage: 'Filigran Ekle',
    qrCodeGenerator: 'QR Kod Oluşturucu',
    qrCodeScanner: 'QR Kod Tarayıcı',
    aboutUs: 'Hakkımızda',
    faceBlur: 'Yüz Bulanıklaştırma',
  },

  hero: {
    heading: 'İhtiyacınız Olan Tüm Görüntü Araçları',
    subheading: 'Görüntüleri dönüştürmek, sıkıştırmak, yeniden boyutlandırmak, kırpmak, düzenlemek ve dönüştürmek için ücretsiz çevrimiçi araçlar. Tüm işlemler tarayıcınızda gerçekleşir — hızlı ve güvenli.',
  },

  tools: {
    compressImage: { title: 'Görüntü Sıkıştır', desc: 'JPG, PNG, SVG ve GIF\'i kaliteyi koruyarak sıkıştırın.' },
    resizeImage: { title: 'Görüntü Boyutlandır', desc: 'Yüzde veya piksel olarak boyutlandırın.' },
    cropImage: { title: 'Görüntü Kırp', desc: 'JPG, PNG ve GIF\'i kolayca kırpın.' },
    convertToJpg: { title: 'JPG\'ye Dönüştür', desc: 'PNG, GIF, TIF, SVG, WEBP ve diğerlerini toplu olarak JPG\'ye dönüştürün.' },
    convertFromJpg: { title: 'JPG\'den Dönüştür', desc: 'JPG görüntülerini PNG ve GIF\'e dönüştürün.' },
    qrCodeGenerator: { title: 'QR Kod Oluşturucu', desc: 'URL, metin, WiFi, kişiler ve daha fazlası için özel QR kodları oluşturun.' },
    qrCodeScanner: { title: 'QR Kod Tarayıcı', desc: 'Kamera veya görüntü yükleyerek QR kodlarını anında tarayın.' },
    blurFace: { title: 'Yüz Bulanıklaştır', desc: 'Gizlilik için görüntülerdeki yüzleri otomatik olarak algılayın ve bulanıklaştırın.' },
    removeBackground: { title: 'Arka Planı Kaldır', desc: 'Yüksek doğrulukla görüntü arka planlarını hızla kaldırın.' },
    watermarkImage: { title: 'Filigran Ekle', desc: 'Saniyeler içinde görüntülere filigran ekleyin.' },
  },

  whyChoose: {
    label: 'Neden Bizi Seçmelisiniz',
    heading: 'Görüntü Düzenlemenin Daha Akıllı Yolu',
    subheading: 'Dünya genelinde binlerce yaratıcı, tasarımcı ve geliştirici tarafından güvenilen araçlar.',
    reasons: {
      fast: { title: 'Şimşek Hızında', desc: 'Tüm işlemler doğrudan tarayıcınızda gerçekleşir. Harici sunuculara yükleme yok.' },
      private: { title: '%100 Güvenli ve Özel', desc: 'Dosyalarınız asla cihazınızdan ayrılmaz. Görüntülerinizi depolamıyor veya paylaşmıyoruz.' },
      noLimits: { title: 'Sınır Yok, Kayıt Yok', desc: 'Tüm araçları istediğiniz kadar kullanın — tamamen ücretsiz.' },
      quality: { title: 'Profesyonel Kalite', desc: 'Algoritmalarımız profesyonel düzeyde sonuçlar sağlar.' },
      batch: { title: 'Toplu İşleme', desc: 'Birden fazla dosyayı aynı anda işleyin.' },
      everywhere: { title: 'Her Yerde Çalışır', desc: 'Masaüstü, tablet ve telefonda mükemmel çalışır.' },
    },
    stats: {
      imagesProcessed: 'İşlenen Görüntü',
      countriesServed: 'Hizmet Verilen Ülke',
      uptime: 'Çalışma Süresi',
      freeTools: 'Ücretsiz Araç',
    },
  },

  footer: {
    tagline: 'Ücretsiz çevrimiçi görüntü araçları — saniyeler içinde görüntüleri dönüştürün, sıkıştırın, boyutlandırın, kırpın ve düzenleyin.',
    imageTools: 'Görüntü Araçları',
    moreTools: 'Daha Fazla Araç',
    company: 'Şirket',
    contact: 'İletişim',
    allRightsReserved: 'Tüm hakları saklıdır.',
    privacyPolicy: 'Gizlilik Politikası',
    termsOfService: 'Kullanım Şartları',
  },

  faq: {
    badge: 'SSS',
    heading: 'Sık Sorulan Sorular',
    subheading: 'Bu araçlar hakkındaki yaygın sorulara hızlı yanıtlar.',
    stillHaveQuestions: 'Hâlâ sorunuz var mı? Yardımcı olmaktan mutluluk duyarız!',
    reachOut: 'Ekibimizle İletişime Geçin',
    questionHeader: 'Soru',
  },

  contactForm: {
    badge: 'Bize Ulaşın',
    title: 'Bize Ulaşın',
    subtitle: 'Sizden haber almak isteriz. Bize bir mesaj gönderin!',
    nameLabel: 'Ad',
    namePlaceholder: 'Adınız Soyadınız',
    emailLabel: 'E-posta',
    emailPlaceholder: 'siz@email.com',
    subjectLabel: 'Konu',
    subjectPlaceholder: 'Bu ne hakkında?',
    messageLabel: 'Mesaj',
    messagePlaceholder: 'Mesajınızı buraya yazın…',
    errName: 'Ad gereklidir',
    errEmail: 'E-posta gereklidir',
    errEmailInvalid: 'Geçerli bir e-posta girin',
    errSubject: 'Konu gereklidir',
    errMessage: 'Mesaj gereklidir',
    sending: 'Gönderiliyor…',
    send: 'Mesaj Gönder',
    successTitle: 'Mesaj Gönderildi!',
    successMsg: 'Bize ulaştığınız için teşekkürler. En kısa sürede size döneceğiz.',
    sendAnother: 'Başka Mesaj Gönder',
    sendError: 'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
  },

  about: {
    label: 'Hakkında',
    heading: 'Yaratıcılar İçin, Yaratıcılar Tarafından',
    subheading: 'Güçlü görüntü araçlarının ücretsiz, hızlı ve herkes tarafından erişilebilir olması gerektiğine inanıyoruz.',
    missionTitle: 'Misyonumuz',
    missionText: 'photremium.com, basit bir hedefle oluşturuldu: web\'de en sezgisel, en hızlı ve en gizli görüntü düzenleme deneyimini sunmak.',
    privacyTitle: 'Önce Gizlilik',
    privacyText: 'Görüntülerinizi uzaktan yüklemez, depolamaz veya işlemez. Her şey cihazınızda kalır.',
    techTitle: 'Modern Teknoloji',
    techText: 'WebAssembly, Canvas API ve modern React dahil en son web teknolojileriyle oluşturulmuştur.',
    communityTitle: 'Topluluk Odaklı',
    communityText: 'Her özellik gerçek kullanıcı geri bildirimlerinden ilham alır.',
    globalTitle: 'Küresel Erişim',
    globalText: '120\'den fazla ülkeden yaratıcılar tarafından kullanılıyor.',
  },

  seo: {
    homeTitle: 'photremium.com — Ücretsiz Çevrimiçi Görüntü Dönüştürücü, Sıkıştırıcı ve Editör',
    homeDesc: 'Görüntüleri ücretsiz çevrimiçi dönüştürün, sıkıştırın, boyutlandırın, kırpın ve düzenleyin.',
    homeKeywords: 'görüntü dönüştürücü, görüntü sıkıştırıcı, görüntü boyutlandır, görüntü kırp, fotoğraf editörü',
    aboutTitle: 'photremium.com Hakkında — Misyonumuz',
    aboutDesc: 'Milyonlarca kişi tarafından güvenilen ücretsiz çevrimiçi görüntü araç seti photremium.com hakkında bilgi edinin.',
    aboutKeywords: 'photremium.com hakkında, görüntü araçları, ücretsiz görüntü editörü',
  },

    privacyPolicyPage: {
    seo: {
      title: 'Gizlilik Politikası — Photremium | Sunucu Yüklemesi Yok, Sıfır Veri Depolama',
      description: 'Photremium\'un Gizlilik Politikası gizliliğinizi nasıl koruduğumuzu açıklar. Tüm görüntü işleme %100 tarayıcınızda gerçekleşir; herhangi bir sunucuya dosya yüklenmez, kişisel veriler toplanmaz, takip yapılmaz.',
      ogTitle: 'Gizlilik Politikası — Photremium | Yükleme Yok, Sıfır Depolama',
      ogDescription: 'Dosyalarınız cihazınızda kalır. Photremium, sunucu bağlantısı olmadan, veri saklanmadan ve izleme olmadan tüm görüntüleri tarayıcınızda yerel olarak işler.',
      twitterTitle: 'Gizlilik Politikası — Photremium',
      twitterDescription: '%100 tarayıcı tabanlı görsel araçları. Yükleme yok, depolama yok, izleme yok. Gizlilik politikamızın tamamını okuyun.',
      schemaName: 'Gizlilik Politikası - Photremium',
      schemaDescription: 'Photremium Gizlilik Politikası - sunucuya yükleme yok, veri saklanmıyor, %100 tarayıcıda görüntü işleme yok.'
    },
    hero: {
      badge: 'Gizlilik Politikası',
      titlePrefix: 'Gizliliğiniz Bizimdir',
      titleHighlight: 'En Yüksek Öncelik',
      subPrefix: 'photremium.com basit bir prensip üzerine inşa edilmiştir:',
      subStrong: 'dosyalarınız asla cihazınızdan ayrılmaz',
      subSuffix: 'Bu sitedeki her resim aracı tamamen tarayıcınızın içinde çalışır. Yükleme yok. Bulut yok. Uzlaşma yok.',
      effectiveLabel: 'Etkili',
      lastUpdatedLabel: 'Son güncelleme',
      worldwideLabel: 'Dünya çapında geçerlidir'
    },
    trustCards: [
      {
        title: 'Sunucu Yüklemesi Yok',
        desc: 'Dosyalarınız asla cihazınızdan ayrılmaz. Tüm işlemler %100 tarayıcıda gerçekleştirilir.'
      },
      {
        title: 'Sıfır Veri Depolama',
        desc: 'Sizinle, görsellerinizle veya etkinliklerinizle ilgili hiçbir şeyi saklamayız.'
      },
      {
        title: 'Takip Yok',
        desc: 'Davranış takibi yok, parmak izi yok, profil çıkarma yok.'
      },
      {
        title: 'GDPR Dostu',
        desc: 'Baştan sona küresel gizlilik düzenlemelerine uyacak şekilde tasarlandı.'
      }
    ],
    contentsTitle: 'İçindekiler',
    toc: {
      overview: 'Genel Bakış',
      'no-upload': 'Sunucu İşleme Yok',
      'data-collect': 'Topladığımız Veriler',
      cookies: 'Çerezler ve Depolama',
      'third-party': 'Üçüncü Taraf Hizmetleri',
      analytics: 'Analitik',
      children: 'Çocukların Gizliliği',
      rights: 'Haklarınız',
      security: 'Güvenlik',
      changes: 'Politika Değişiklikleri',
      contact: 'Bize Ulaşın'
    },
    sections: {
      overview: {
        title: '1. Genel Bakış',
        subtitle: 'Bu politikanın kapsamı',
        p1Prefix: 'Bu Gizlilik Politikasında bunun nasıl yapılacağı açıklanmaktadır',
        p1Middle: '("biz", "bize" veya "bizim") idare eder - veya daha doğrusu,',
        p1Italic: 'idare edemiyor',
        p1Suffix: 'adresindeki ücretsiz çevrimiçi görsel araçlarımızı kullandığınızda kişisel bilgileriniz',
        p2: 'Dosyaları işlenmek üzere uzak sunuculara gönderen geleneksel web uygulamalarının aksine, photremium.com, cihazınızda her işlemi yerel olarak gerçekleştirmek için modern tarayıcı API\'lerini (Canvas API, WebAssembly, WebWorkers) kullanır. Sonuç: veri aktarımı yok, depolama yok, risk yok.',
        calloutLabel: 'Düz İngilizce özeti:',
        calloutText: 'Görüntülerinizi göremiyoruz, istemiyoruz ve teknolojimiz, asla göremeyeceğimiz şekilde özel olarak tasarlanmıştır.'
      },
      noUpload: {
        title: '2. Sunucu İşleme Yok - Hiçbir Zaman',
        subtitle: 'Araçlarımız aslında nasıl çalışıyor?',
        introPrefix: 'Photremium.com\'daki her araç (görüntü dönüştürücü, sıkıştırıcı, yeniden boyutlandırıcı, arka plan temizleyici, yüz bulanıklaştırma, filigran, kırpma ve QR kodu araçları) dosyalarınızı işler',
        introStrong: '%100 web tarayıcınızın içinde',
        introSuffix: 'istemci tarafı JavaScript ve WebAssembly kullanarak.',
        points: [
          {
            label: 'Hiçbir dosya yükleme işlemi gerçekleşmez.',
            text: 'Bir dosya seçtiğinizde, tarayıcınızın Dosya API\'si tarafından okunur ve bellekte işlenir; hiçbir zaman ağ üzerinden gönderilmez.'
          },
          {
            label: 'Hiçbir sunucu resminizi almıyor.',
            text: 'CDN\'miz, dosyalarınızı değil, yalnızca uygulamayı çalıştırmak için gereken HTML, CSS ve JavaScript varlıklarını sunar.'
          },
          {
            label: 'Geçici depolama yok.',
            text: 'İşlenen sonuçlar yalnızca tarayıcınızın belleğinde bulunur ve sayfayı kapattığınızda veya sayfadan ayrıldığınızda yayınlanır.'
          },
          {
            label: 'Çevrimdışı çalışır.',
            text: 'Çoğu araç, ilk sayfa yüklendikten sonra internet bağlantısı olmadan çalışmaya devam eder; bu da herhangi bir sunucunun dahil olmadığının bir başka kanıtıdır.'
          }
        ],
        callout: 'Bunu kendiniz doğrulayabilirsiniz: Geliştirici Araçları\'nda tarayıcınızın Ağ sekmesini açın, bir görüntü seçin ve herhangi bir harici sunucuya hiçbir dosya verisinin aktarılmadığını doğrulayın.'
      },
      dataCollect: {
        title: '3. Topladığımız (ve Toplamadığımız) Veriler',
        subtitle: 'Veri uygulamalarında tam şeffaflık',
        headers: {
          type: 'Veri Türü',
          collected: 'Toplanmış mı?',
          whereWhy: 'Nerede / Neden'
        },
        rows: [
          {
            type: 'Resimleriniz / dosyalarınız',
            badge: 'Asla',
            variant: 'yeşil',
            showX: true,
            whereWhy: 'Tamamen tarayıcınızda işlenir; asla iletilmez'
          },
          {
            type: 'İsim / e-posta adresi',
            badge: 'Asla',
            variant: 'yeşil',
            showX: true,
            whereWhy: 'Herhangi bir aracı kullanmak için hesap veya kayıt olmanıza gerek yoktur'
          },
          {
            type: 'IP adresi',
            badge: 'Asgari',
            variant: 'gri',
            showX: false,
            whereWhy: 'Standart web sunucusu günlükleri <= 30 gün süreyle saklanır, kimliğe bağlı değildir'
          },
          {
            type: 'Tarayıcı / İşletim Sistemi türü',
            badge: 'Asgari',
            variant: 'gri',
            showX: false,
            whereWhy: 'Tarayıcınız tarafından otomatik olarak gönderilir; yalnızca uyumluluk için kullanılır'
          },
          {
            type: 'Ziyaret edilen sayfalar / tıklamalar',
            badge: 'Toplu',
            variant: 'mavi',
            showX: false,
            whereWhy: 'Yalnızca anonim analizler (kişisel kimlik tespiti yok)'
          },
          {
            type: 'Dil tercihi',
            badge: 'Yalnızca yerel',
            variant: 'mavi',
            showX: false,
            whereWhy: 'Cihazınızdaki localStorage\'a kaydedildi; bize asla gönderilmedi'
          },
          {
            type: 'Ödeme / finansal veriler',
            badge: 'Asla',
            variant: 'yeşil',
            showX: true,
            whereWhy: 'photremium.com hiçbir ödeme gerektirmeden tamamen ücretsizdir'
          }
        ]
      },
      cookies: {
        title: '4. Çerezler ve Yerel Depolama',
        subtitle: 'Cihazınızda neler saklanır?',
        intro: 'photremium.com reklam çerezleri, siteler arası izleme çerezleri ve üçüncü taraf çerezleri kullanmaz. Kullandığımız tek tarayıcı depolama alanı temel site işlevleri içindir.',
        points: [
          {
            label: 'Dil tercihi',
            text: 'Sitenin ziyaretler arasında tercih ettiğiniz dili hatırlaması için localStorage\'da saklanır. Hiçbir zaman sunucularımıza gönderilmedi.'
          },
          {
            label: 'Tema / kullanıcı arayüzü tercihleri',
            text: 'Bir görüntüleme tercihi ayarlarsanız, bu tercih yerel olarak yalnızca cihazınıza kaydedilir.'
          },
          {
            label: 'Oturum çerezi yok.',
            text: 'photremium.com\'un oturum açma sistemi yoktur, dolayısıyla hiçbir oturum kimliği çerezi yazılmaz.'
          }
        ],
        callout: 'Tarayıcınızın ayarlarını kullanarak (Ayarlar -> Gizlilik -> Tarama verilerini temizle -> Önbelleğe alınmış veriler ve çerezler) tüm photremium.com yerel depolama alanını istediğiniz zaman temizleyebilirsiniz. Bunun, araçları kullanma beceriniz üzerinde hiçbir etkisi yoktur.'
      },
      thirdParty: {
        title: '5. Üçüncü Taraf Hizmetleri',
        subtitle: 'Kullandığımız harici hizmetler ve nedenleri',
        intro: 'photremium.com, yalnızca altyapı ve performans için minimum düzeyde güvenilir üçüncü taraf hizmetleri kullanır. Bu hizmetlerin hiçbiri görsellerinizi veya kişisel olarak tanımlanabilecek herhangi bir bilgiyi almaz.',
        headers: {
          service: 'Hizmet',
          purpose: 'Amaç',
          dataShared: 'Paylaşılan Veriler',
          privacyPolicy: 'Gizlilik Politikası'
        },
        rows: [
          {
            service: 'Cloudflare Sayfaları',
            purpose: 'Site varlıklarının barındırılması ve CDN teslimi',
            dataShared: 'IP adresi, HTTP başlıkları (standart)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Harika Yazı Tipi',
            purpose: 'CDN\'den yüklenen simge yazı tipleri',
            dataShared: 'IP adresi (yalnızca CSS isteği)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google Yazı Tipleri',
            purpose: 'Yazı tipi yükleme (varsa)',
            dataShared: 'IP adresi (yalnızca yazı tipi isteği)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Verilerinizi reklamverenlerle, veri komisyoncularıyla veya yukarıda listelenen altyapı sağlayıcılarının dışındaki herhangi bir üçüncü tarafla paylaşmıyoruz.'
      },
      analytics: {
        title: '6. Analitik',
        subtitle: 'Toplu, gizliliğe saygılı kullanım verileri',
        introPrefix: 'Hangi araçların popüler olduğunu ve siteyi nasıl geliştirebileceğimizi anlamak için şunları toplayabiliriz:',
        introStrong: 'toplu, anonimleştirilmiş',
        introSuffix: 'aşağıdakiler gibi kullanım istatistikleri:',
        points: [
          'Araç başına sayfa görüntüleme sayısı (kullanıcı kimliği yok)',
          'Yönlendirme kaynağı (ör. Google arama, doğrudan bağlantı) — kişisel veri yok',
          'Ülke düzeyinde coğrafi veriler (şehir veya kesin konum değil)',
          'Uyumluluk analizi için tarayıcı / cihaz türü'
        ],
        calloutLabel: 'Hiçbir veri kişisel olarak sizinle bağlantılı değildir.',
        calloutText: 'Google Analytics veya Meta Pixel kullanmıyoruz. Kullandığımız tüm analizler gizliliğe öncelik veren araçlardır (ör. Makul veya benzeri).'
      },
      children: {
        title: '7. Çocukların Gizliliği',
        subtitle: 'COPPA ve çocuk güvenliği uyumluluğu',
        p1: 'photremium.com, 13 yaşın (veya GDPR uyarınca Avrupa Birliği\'nde 16 yaşın) altındaki çocuklardan bilerek herhangi bir kişisel bilgi toplamaz. Hiçbir kullanıcıdan kişisel veri toplamadığımız için, genç kullanıcılar için yapılacak özel bir şey yoktur; site herkes için eşit derecede güvenlidir.',
        p2Prefix: 'Bir çocuğun bir şekilde kişisel bilgilerini iletişim formumuz aracılığıyla gönderdiğini düşünüyorsanız lütfen şu adresten hemen bizimle iletişime geçin:',
        p2Suffix: 've derhal sileceğiz.'
      },
      rights: {
        title: '8. Haklarınız',
        subtitle: 'GDPR, CCPA ve küresel gizlilik hakları',
        intro: 'Photremium.com kişisel olarak tanımlanabilecek hiçbir bilgi toplamadığından, veri sahibi hakların çoğu önemsiz bir şekilde geçerlidir; hakkınızda erişebileceğiniz, düzeltebileceğiniz veya silebileceğiniz hiçbir veri yoktur. Bununla birlikte, aşağıdaki hakları tam olarak kabul ediyor ve bunlara saygı duyuyoruz:',
        points: [
          {
            label: 'Erişim hakkı',
            text: 'Hakkınızda tuttuğumuz verilerin bir kopyasını isteyebilirsiniz. (Anonimleştirilmiş günlüklerin ötesinde bir şey yoktur.)'
          },
          {
            label: 'Düzeltme hakkı',
            text: 'Yanlış kişisel verilerinizin düzeltilmesini talep edebilirsiniz.'
          },
          {
            label: 'Silme hakkı ("Unutulma hakkı")',
            text: 'Tuttuğumuz tüm kişisel verilerin silinmesini talep edebilirsiniz (GDPR Madde 17, CCPA).'
          },
          {
            label: 'İtiraz etme / vazgeçme hakkı',
            text: 'Tarayıcı düzeyinde bir devre dışı bırakma veya reklam engelleme aracı kullanarak gelecekteki herhangi bir analiz koleksiyonundan vazgeçebilirsiniz.'
          },
          {
            label: 'Veri taşınabilirliği hakkı',
            text: 'Tüm çalışmalarınız doğrudan cihazınıza indirilir; dışa aktarma isteği gerekmez.'
          }
        ],
        callout: 'Bu haklar, yargı yetkisine bakılmaksızın dünya çapındaki tüm kullanıcılar için geçerlidir; temel olarak en yüksek standardı (GDPR) uyguluyoruz.'
      },
      security: {
        title: '9. Güvenlik',
        subtitle: 'Deneyiminizi nasıl koruyoruz',
        intro: 'En güvenli veriler hiçbir zaman toplanmayan verilerdir. photremium.com istemci tarafı mimarisi, dosyalarınız hiçbir zaman sunucularımızda olmadığından sunucu ihlalinin dosyalarınızı açığa çıkaramayacağı anlamına gelir. Ek güvenlik önlemleri şunları içerir:',
        points: [
          {
            label: 'HTTPS yaptırımı',
            text: 'Tarayıcınız ile CDN\'miz arasındaki tüm trafik, HSTS\'li TLS 1.2+ aracılığıyla şifrelenir.'
          },
          {
            label: 'İçerik Güvenliği Politikası (CSP)',
            text: 'Katı başlıklar, siteler arası komut dosyası çalıştırmayı ve satır içi komut dosyası eklemeyi önler.'
          },
          {
            label: 'Düzenli bağımlılık denetimleri',
            text: 'Bilinen güvenlik açıklarını gidermek için npm paketlerini düzenli olarak denetleyip güncelliyoruz.'
          }
        ],
        disclosurePrefix: 'Sorumlu açıklama',
        disclosureTextPrefix: 'Bir güvenlik sorunu mu buldunuz? Bize e-posta gönderin',
        disclosureTextSuffix: 've 48 saat içinde cevap vereceğiz.'
      },
      changes: {
        title: '10. Bu Politikadaki Değişiklikler',
        subtitle: 'Politika güncellemelerini nasıl ele alıyoruz?',
        intro: 'Uygulamalarımız, araçlarımız veya yasal gereksinimlerimizdeki değişiklikleri yansıtacak şekilde bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Bunu yaptığımızda:',
        points: [
          {
            label: '"Son Güncelleme"',
            text: 'Bu sayfanın üst kısmındaki tarih revize edilecektir.'
          },
          {
            label: 'Malzeme değişiklikleri',
            text: 'en az 30 gün süreyle ana sayfada dikkat çekici bir duyuruyla duyurulacaktır.'
          },
          {
            label: 'Önceki sürümler',
            text: 'Bu politika arşivlenecek ve talep üzerine sunulacaktır.'
          }
        ],
        outro: 'Değişiklikler yayınlandıktan sonra photremium.com\'u kullanmaya devam etmek, güncellenen politikanın kabul edildiği anlamına gelir. Bu sayfayı periyodik olarak incelemenizi öneririz.'
      },
      contact: {
        title: '11. İletişim ve Veri Talepleri',
        subtitle: 'Gizlilik konusunda iletişime geçin',
        p1Prefix: 'Bu Gizlilik Politikasıyla ilgili her türlü soru, endişe veya resmi veri talebi için lütfen bizimle iletişime geçin. Gizlilikle ilgili tüm sorulara şu kapsamda yanıt vermeyi amaçlıyoruz:',
        p1Strong: '5 iş günü'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Gizlilik Sorularınız mı var?',
      privacyQuestionsDesc: 'Gizlilikle ilgili sorularınızı, veri taleplerinizi veya endişelerinizi bize gönderin, hemen yanıt verelim.',
      versionHistoryTitle: 'Sürüm Geçmişi',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'Yeni!',
    download: 'İndir',
    downloadAll: 'Hepsini İndir',
    downloadAs: 'Şu şekilde indir:',
    zip: 'ZIP',
    separate: 'Ayrı',
    upload: 'Yükle',
    dragDrop: 'Görüntüleri buraya sürükleyin veya göz atmak için tıklayın',
    remove: 'Kaldır',
    reset: 'Sıfırla',
    apply: 'Uygula',
    cancel: 'İptal',
    clear: 'Temizle',
    close: 'Kapat',
    save: 'Kaydet',
    processing: 'İşleniyor...',
    noFiles: 'Dosya seçilmedi',
    selectFiles: 'Dosya Seç',
    or: 'veya',
    browseFiles: 'Dosyalara Gözat',
    dropHere: 'Görüntüleri buraya bırakın',
    chooseFiles: 'Dosya Seç',
    pasteHint: 'Görüntü de yapıştırabilirsiniz',
    quality: 'Kalite',
    width: 'Genişlik',
    height: 'Yükseklik',
    format: 'Format',
    compression: 'Sıkıştırma',
    preview: 'Önizleme',
    original: 'Orijinal',
    result: 'Sonuç',
    before: 'Önce',
    after: 'Sonra',
    startOver: 'Yeniden Başla',
    startOverConfirm: 'Tüm görüntüleri kaldırıp yeniden başlayacak mısınız?',
    addMoreImages: 'Daha Fazla Görüntü Ekle',
    addImage: 'Görüntü Ekle',
    images: 'görüntü',
    totalSize: 'Toplam Boyut',
    size: 'Boyut',
    type: 'Tür',
    unsavedEdits: 'Kaydedilmemiş düzenlemeleriniz var. Bu sayfadan ayrılmak istiyor musunuz?',
    compareSlider: 'Karşılaştırma Kaydırıcısı',
    toggleToolsPanel: 'Araç Panelini Değiştir',
    closePanel: 'Paneli Kapat',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    fit: 'Sığdır',
    none: 'Hiçbiri',
  },

  compressor: {
    seo: {
      uploadTitle: 'Görüntü Sıkıştırıcı — JPG, PNG, SVG, GIF Ücretsiz Sıkıştır | photremium.com',
      uploadDesc: 'JPG, PNG, SVG ve GIF görüntülerini çevrimiçi ücretsiz sıkıştırın. Kaliteyi koruyarak dosya boyutunu %80\'e kadar küçültün.',
      uploadKeywords: 'görüntü sıkıştırıcı, jpg sıkıştır, png sıkıştır, görüntü boyutunu küçült',
      workspaceTitle: 'Görüntü Sıkıştırılıyor — photremium.com Görüntü Sıkıştırıcı',
      workspaceDesc: 'Sıkıştırma seviyesini ayarlayın ve optimize edilmiş görüntüleri indirin.',
      workspaceKeywords: 'görüntü sıkıştırma, görüntü optimizasyonu',
    },
    title: 'Görüntü Sıkıştırıcı',
    desc: 'JPG, PNG ve GIF görüntülerini %80\'e kadar sıkıştırın. Hızlı ve güvenli.',
    toCompress: 'sıkıştırmak için',
    compressionForAll: 'Tüm görüntüler için sıkıştırma',
    summary: 'Özet',
    originalSize: 'Orijinal Boyut',
    compressed: 'Sıkıştırıldı',
    saved: 'Tasarruf',
    compressionLabel: 'Sıkıştırma:',
    compressing: 'Sıkıştırılıyor…',
    compressDownload: 'Sıkıştır ve İndir',
    lowQualityWarning: 'Yüksek sıkıştırma, görüntü netliğini belirgin şekilde azaltabilir.',
    blog: {
      tocTitle: 'İçindekiler',
      title: 'Görüntü Sıkıştırıcı Blogu',
      formatsIntro: 'Aracımız tüm görüntü formatlarını destekler; böylece istediğiniz görüntüyü sorunsuzca sıkıştırabilirsiniz. Tüm formatların listesi aşağıdadır:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Görüntü sıkıştırıcı nedir?',
          paragraphs: [
            'Görüntü sıkıştırıcı, görsel kaliteyi mümkün olduğunca korurken dosya boyutunu azaltan bir yazılım veya çevrimiçi hizmettir. Ancak aşırı sıkıştırma, görüntü kalitesini gözle fark edilecek düzeyde düşürebilir.',
          ],
          listTitle: 'TÜRLER:',
          bullets: [
            'Kayıplı sıkıştırma: Görüntü verisinin bir kısmı kaldırılarak dosya boyutu düşürülür. Kalite azalabilir ancak orta seviyede çoğu zaman çıplak gözle belirgin değildir.',
            'Kayıpsız sıkıştırma: Görüntünün görsel kalitesini bozmadan dosya boyutunu azaltır.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Neden aracımızı seçmelisiniz?',
          bullets: [
            'Yapay zekâ destekli görüntü sıkıştırıcı aracımız tüm cihazlarda sorunsuz çalışır ve en iyi sonuçları sunar.',
            'Tek tıkla birden fazla görüntüyü aynı anda sıkıştırabilirsiniz (hatta 100+).',
            'Görüntülerinizi sunucularımıza yüklemeniz gerekmez. Tüm işlemler tarayıcınızda yerel olarak yapılır.',
            'Aracımız tamamen ücretsizdir ve sonsuza kadar ücretsiz kalır. İsterseniz arkadaşlarınızla da paylaşabilirsiniz.',
            'Sıkıştırma yüzdesini ihtiyacınıza göre siz belirleyebilirsiniz.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Adım adım rehber',
          steps: [
            {
              heading: '1. Sıkıştırmak istediğiniz görüntü(leri) seçin.',
              bullets: [
                'Görüntüleri sürükleyip bırakma alanına bırakın.',
                'Ayrıca görüntüleri kopyalayıp (Ctrl + V) ile kutuya yapıştırabilirsiniz.',
                'Dosya gezgini ile seçim yapmak için seç butonunu da kullanabilirsiniz.',
              ],
            },
            {
              heading: '2. Ardından sıkıştırma yüzdesini seçin.',
              bullets: [
                'Yatay kaydırma çubuğu sıkıştırma seviyesini rahatça seçmenizi sağlar. Daha doğru sonuçlar için aşağıdaki aralıkları izleyin.',
              ],
              table: {
                headers: ['Sıkıştırma Yüzdesi', 'Sonuç'],
                rows: [
                  ['1%  ile  40%', 'En iyi kalite'],
                  ['41%  ile  60%', 'Normal kalite (Önerilen)'],
                  ['61%  ile  100%', 'Düşük kalite'],
                ],
              },
            },
            {
              heading: '3. Ne kadar alan tasarrufu sağladığınızı kontrol edin.',
              paragraphs: [
                'Tüm boyut metrikleri gerçek zamanlı gösterilir. Toplamdan ne kadar tasarruf ettiğinizi net şekilde görebilir ve sıkıştırma seviyesini ihtiyacınıza göre ayarlayabilirsiniz.',
              ],
            },
            {
              heading: '4. Anahtar düğmeden indirme seçeneğini belirleyin.',
              bullets: [
                'ZIP: Birden fazla görüntü sıkıştırıyorsanız bu seçenek görünür. Tüm sıkıştırılmış görüntüler tek ZIP dosyasında arşivlenir (çok sayıda görüntü için önerilir).',
                'Ayrı: Bu seçenekle görüntüler tek ZIP yerine ayrı ayrı indirilir (az sayıda görüntü, 10’dan az için önerilir).',
              ],
            },
            {
              heading: '5. Görüntüyü sıkıştırın ve indirin.',
              paragraphs: [
                'Bu düğme, seçtiğiniz indirme seçeneğine göre tüm sıkıştırılmış görüntüleri otomatik olarak indirir.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Görüntü sıkıştırmanın faydaları.',
          bullets: [
            'Depolama maliyetini azaltır: Sıkıştırma ile dosya boyutu küçülür ve depolama alanı tasarrufu sağlanır.',
            'Daha hızlı yükleme: Sıkıştırılmış görüntüler daha hızlı açılır, web sitesi ve uygulama deneyimini iyileştirir.',
            'Gmail sınırı için çözüm: Gmail ekleri 25MB ile sınırlı olduğundan, sıkıştırma daha fazla dosya göndermenizi sağlar.',
            'Daha hızlı paylaşım ve aktarım: Büyük dosyalar daha uzun sürede aktarılır; sıkıştırma zaman ve veri tasarrufu sağlar.',
            'Sunum optimizasyonu: Sıkıştırılmamış görseller sunumları ağırlaştırır, sıkıştırılmış görseller dosya boyutunu ciddi şekilde düşürür.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Desteklenen formatlar.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Görüntü Dönüştürücü — PNG, JPG, WEBP, GIF, SVG Ücretsiz Dönüştür | photremium.com',
      uploadDesc: 'JPG, PNG, WEBP, GIF, SVG, TIFF ve BMP arasında görüntü dönüştürün. Ücretsiz çevrimiçi görüntü format dönüştürücü.',
      uploadKeywords: 'görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',
      workspaceKeywords: 'görüntü dönüştürme, görüntü format dönüştürücü',

      routeKeywords: {

        'png-to-jpg': 'png dönüştürmek için jpg, png to jpg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'jpg-to-png': 'jpg dönüştürmek için png, jpg to png, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'png-to-webp': 'png dönüştürmek için webp, png to webp, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'jpg-to-webp': 'jpg dönüştürmek için webp, jpg to webp, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'webp-to-jpg': 'webp dönüştürmek için jpg, webp to jpg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'webp-to-png': 'webp dönüştürmek için png, webp to png, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'gif-to-jpg': 'gif dönüştürmek için jpg, gif to jpg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'gif-to-png': 'gif dönüştürmek için png, gif to png, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'bmp-to-jpg': 'bmp dönüştürmek için jpg, bmp to jpg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'bmp-to-png': 'bmp dönüştürmek için png, bmp to png, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'svg-to-png': 'svg dönüştürmek için png, svg to png, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'svg-to-jpg': 'svg dönüştürmek için jpg, svg to jpg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'tiff-to-jpg': 'tiff dönüştürmek için jpg, tiff to jpg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'tiff-to-png': 'tiff dönüştürmek için png, tiff to png, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'jpg-to-gif': 'jpg dönüştürmek için gif, jpg to gif, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'png-to-gif': 'png dönüştürmek için gif, png to gif, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'jpg-to-bmp': 'jpg dönüştürmek için bmp, jpg to bmp, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'png-to-bmp': 'png dönüştürmek için bmp, png to bmp, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'webp-to-gif': 'webp dönüştürmek için gif, webp to gif, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'jpg-to-ico': 'jpg dönüştürmek için ico, jpg to ico, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'png-to-ico': 'png dönüştürmek için ico, png to ico, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'jpg-to-svg': 'jpg dönüştürmek için svg, jpg to svg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'png-to-svg': 'png dönüştürmek için svg, png to svg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'webp-to-svg': 'webp dönüştürmek için svg, webp to svg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'gif-to-svg': 'gif dönüştürmek için svg, gif to svg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'bmp-to-svg': 'bmp dönüştürmek için svg, bmp to svg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

        'tiff-to-svg': 'tiff dönüştürmek için svg, tiff to svg, görüntü dönüştürücü, png\'yi jpg\'ye, jpg\'yi png\'ye, webp dönüştürücü',

      },
    },
    title: 'Görüntü Dönüştürücü',
    desc: 'JPG, PNG, WEBP, GIF, SVG, TIFF ve BMP arasında görüntü dönüştürün. Birden fazla dosyayı toplu dönüştürün.',
    toConvert: 'dönüştürmek için',
    convertSettings: 'Dönüştürme Ayarları',
    detected: 'Algılandı',
    convertTo: 'Şuna dönüştür',
    converting: 'Dönüştürülüyor…',
    convertToFormat: '{format}\'a Dönüştür',
    popularConversions: 'Popüler Dönüşümler',
    convertingTo: 'Şuna dönüştürülüyor',
    all: 'Tümü',
  },

  resizer: {
    seo: {
      uploadTitle: 'Görüntü Boyutlandır — JPG, PNG Ücretsiz Boyutlandır | photremium.com',
      uploadDesc: 'Görüntüleri çevrimiçi ücretsiz piksel veya yüzde olarak boyutlandırın.',
      uploadKeywords: 'görüntü boyutlandır, görüntü boyutlandırıcı, jpg boyutlandır, png boyutlandır',
      workspaceTitle: 'Görüntü Boyutlandırılıyor — photremium.com',
      workspaceDesc: 'Görüntüleri çevrimiçi ücretsiz boyutlandırın.',
      workspaceKeywords: 'görüntü boyutlandır, boyutlandırıcı',
    },
    title: 'Görüntü Boyutlandır',
    desc: 'Piksel, yüzde, santimetre veya inç olarak boyutu tanımlayın ve anında boyutlandırın.',
    toResize: 'boyutlandırmak için',
    resizeSettings: 'Boyutlandırma Ayarları',
    resizeBy: 'Şuna göre boyutlandır:',
    byPixels: 'Piksel',
    byPercentage: 'Yüzde',
    byCentimeters: 'Santimetre',
    byInches: 'İnç',
    advanced: 'Gelişmiş',
    lockAspect: 'En-Boy Oranını Kilitle',
    unlockAspect: 'Oranı Kilidi Aç',
    dontEnlarge: 'Orijinal daha küçükse büyütme',
    resizing: 'Boyutlandırılıyor…',
    resizeDownload: 'Boyutlandır ve İndir',
    blog: {
      tocTitle: 'İçindekiler',
      title: 'Görüntü Boyutlandırma Blogu',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Neden görüntü boyutlandırıcı kullanılır?',
          paragraphs: [
            'Görüntü boyutlandırıcı, bir görüntünün boyutlarını değiştirmek için kullanılan bir araç/yazılımdır. Genişliği, yüksekliği veya her ikisini ayarlayarak gerekli boyutu elde edebilirsiniz. Bu, özellikle görsel yükleme/paylaşım boyutu sınırı olan sosyal medya platformlarında çok faydalıdır.',
          ],
          listTitle: 'Örneğin:',
          bullets: [
            'Instagram gönderisi: 1080 x 1080px (kare)',
            'Facebook gönderisi: 1200 x 630px',
            'X (Twitter) gönderisi: 1200 x 675px',
            'Instagram Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Neden bizim görüntü boyutlandırma aracımızı seçmelisiniz?',
          paragraphs: [
            'AI destekli aracımız görüntüleri hassas ve çok hızlı biçimde boyutlandırmanızı sağlar. Her cihazda akıcı çalışır ve uygulama kurulumuna ihtiyaç duymaz. Tüm özellikler tarayıcı üzerinden çevrimiçi kullanılabilir.',
          ],
          bullets: [
            'Aynı anda birden fazla görüntüyü (hatta 100+) boyutlandırabilirsiniz. Güçlü cihazlarda 400–500 görüntü birkaç saniyede işlenebilir.',
            'Tüm işlem tarayıcıda yerel olarak yapılır. Görüntüleri sunucumuza yüklemeniz gerekmez; dosyalar cihazdan çıkmaz.',
            'Birden çok boyutlandırma birimi desteklenir.',
            'Tek bir onay kutusuyla en-boy oranını koruyabilirsiniz.',
            'Birden çok görüntüde ayrı ayrı indirme veya ZIP indirme seçenekleri vardır.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Adım adım rehber',
          steps: [
            {
              heading: 'Önce boyutlandırmak istediğiniz görüntü(leri) seçin. Seçmek için birden fazla yol vardır.',
              bullets: [
                'Görüntüleri sürükleyip bırakma kutusuna bırakabilirsiniz.',
                '“Ctrl + V” kısayoluyla görüntü yapıştırabilirsiniz.',
                'Veya “Choose Files” düğmesiyle dosya gezgininden seçebilirsiniz.',
              ],
            },
            {
              heading: 'Sonra bir boyutlandırma birimi seçin. Şu birimler mevcuttur:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Birim seçtikten sonra genişlik ve yüksekliği ayarlayın. İsterseniz onay kutusuyla en-boy oranını koruyabilirsiniz.',
            },
            {
              heading: 'Orijinal boyuttan daha büyük yapmamak için “Don’t enlarge if original is smaller” seçeneğini işaretleyin.',
            },
            {
              heading: 'Ardından indirme seçeneklerinden birini seçin.',
              bullets: [
                'Tüm çıktı görüntülerini tek bir zip dosyası olarak almak için ZIP seçin.',
                'Her görüntüyü ayrı indirmek için “separate” seçin.',
              ],
            },
            {
              heading: 'Son olarak “Resize & Download” düğmesine tıklayın ve seçtiğiniz seçeneğe göre indirin.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Görüntü boyutlandırma aracının faydaları: en büyük fayda, görüntülerin web sayfaları ve sosyal medya gönderilerinde doğru şekilde yerleşmesini sağlamasıdır.',
          tocLabel: '4. Görüntü boyutlandırma aracının faydaları',
          bullets: [
            'UX iyileştirme: doğru boyut ve doğru yerleşim kullanıcı deneyimini belirgin şekilde iyileştirir.',
            'Sosyal medya uyumu: birçok platform görsel boyut sınırı uygular; araç bu sınırlara uyumu kolaylaştırır.',
            'Responsive tasarım desteği: geliştiriciler farklı cihazlar için farklı görsel boyutlarına ihtiyaç duyar.',
            'Daha iyi seçenek: görüntüyü esnetmek veya sert kırpmak yerine boyutlandırma genelde daha iyi sonuç verir.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Desteklenen formatlar: görüntü boyutlandırma aracımız her tür formatta görüntü seçimini destekler. Desteklenen formatlar aşağıdadır:',
          tocLabel: '5. Desteklenen formatlar',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Görüntü Kırp — JPG, PNG, GIF Ücretsiz Kırp | photremium.com',
      uploadDesc: 'JPG, PNG ve GIF görüntülerini çevrimiçi ücretsiz kolayca kırpın.',
      uploadKeywords: 'görüntü kırp, görüntü kırpıcı, jpg kırp, png kırp',
      workspaceTitle: 'Görüntü Kırpılıyor — photremium.com',
      workspaceDesc: 'Görüntüleri çevrimiçi ücretsiz kırpın.',
      workspaceKeywords: 'görüntü kırp, kırpıcı',
    },
    title: 'Görüntü Kırp',
    desc: 'Görsel editörle JPG, PNG, GIF ve diğerlerini kırpın. Önceden ayarlanmış oranlar veya serbest kırpma.',
    toCrop: 'kırpmak için',
    cropSettings: 'Kırpma Ayarları',
    widthPx: 'Genişlik (px)',
    heightPx: 'Yükseklik (px)',
    positionX: 'Konum X (px)',
    positionY: 'Konum Y (px)',
    cropTemplate: 'Kırpma Şablonu',
    landscape: 'Yatay',
    portrait: 'Dikey',
    square: 'Kare',
    freeform: 'Serbest Form',
    cropping: 'Kırpılıyor…',
    cropDownload: 'Kırp ve İndir',
    cropDownloadAll: 'Kırp ve Tümünü İndir',
    saveNext: 'Kaydet ve Sonraki',
    croppedNofTotal: '{total} görüntüden {n} tanesi kırpıldı.',
    downloadN: '{n} Tane İndir',
    blog: {
      tocTitle: 'İçindekiler',
      title: 'Görüntü Kırpıcı Blogu',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Neden görüntü kırpıcı kullanılır?',
          paragraphs: [
            'Görüntü kırpıcı, bir görüntüyü istenen şekle kırpmak için kullanılan bir yazılım aracıdır. İstenilen bölümü bırakıp dıştaki istenmeyen alanları kaldırmak için yaygın olarak kullanılır. Bu araç, kırpmak istediğiniz konuma göre ayarlayabileceğiniz bir kırpma kutusu sunar.',
          ],
          listTitle: 'Örneğin:',
          bullets: [
            'Kendinizi grup fotoğrafından kırpmak.',
            'Adınızı bir listeden kırpmak.',
            'Tam ekran ekran görüntüsünden ilerleme çubuğunu kırpmak.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Neden bizim görüntü kırpıcımızı seçmelisiniz?',
          paragraphs: [
            'Görüntü kırpma aracımız, görüntüleri hassas ve çok hızlı şekilde kırpmanıza olanak tanır. Sadece kırpmak istediğiniz konuma göre kırpma kutusunun boyutunu ayarlamanız yeterlidir. Görüntü seçimi için neredeyse tüm görüntü formatları desteklenir.',
          ],
          bullets: [
            'Cihazınızın desteklediği kadar görüntüyü kırpabilirsiniz. Yüksek performanslı bir cihazınız varsa, 100+ görüntüyü aynı anda gecikme veya başka sorun olmadan bile kırpabilirsiniz.',
            'Görüntüleriniz yerel tarayıcınızda işlenir. Görüntüleri sunucumuza yüklemeniz gerekmez, bu nedenle hiçbir görüntü cihazınızdan çıkmaz. Kişisel görüntülerinizi güvensizlik veya risk olmadan kırpabilirsiniz.',
            'Birçok araç geçersiz görüntü formatı hatası verir. Görüntü kırpma aracımız neredeyse tüm görüntü formatlarını destekleyerek bu sorunu çözer.',
            'Aynı anda çok sayıda görüntü kırpıyorsanız, aracımız kırpılan görüntüleri tercihinize göre ZIP olarak veya ayrı ayrı indirmenize olanak tanır.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Adım adım rehber',
          steps: [
            {
              heading: '1. Öncelikle kırpmak istediğiniz görüntüyü seçin. Görüntü kırpma aracımız aynı anda birden fazla görüntü seçimini de destekler.',
              bullets: [
                'Kırpmak için görüntüleri sürükleyip bırakma kutusuna bırakın.',
                'Ayrıca kırpma kutusunda bulunan choose files düğmesine tıklayarak dosya gezgini üzerinden görüntü seçebilirsiniz.',
                'Görüntüleri bırakma kutusuna yapıştırmak için Ctrl + V kısayolu da desteklenir.',
              ],
            },
            {
              heading: '2. Ardından, görüntü üzerinde kırpma kutusunun boyutunu ve konumunu ayarlayın.',
            },
            {
              heading: '3. Yükseklik, genişlik, yatay konum ve dikey konum değerlerini elle girerek kırpma kutusunu da ayarlayabilirsiniz.',
            },
            {
              heading: '4. Ayrıca bazı hazır şablonları da kullanabilirsiniz:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Sonra indirme seçeneklerinden birini seçmeniz gerekir.',
              bullets: [
                'ZIP: Aynı anda birçok görüntü kırpıyorsanız ve tüm kırpılmış görüntüleri tek dosya olarak indirmek istiyorsanız bu seçeneği seçin.',
                'Separate: Tüm kırpılmış görüntüleri ayrı ayrı indirmek istiyorsanız geçiş düğmesinden bu seçeneği seçin.',
              ],
            },
            {
              heading: '6. Ardından Crop & Download düğmesine tıklayın; tüm kırpılmış görüntüleriniz ön ayarlı ölçülerinize göre indirilecektir.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Görüntü Kırpmanın Faydaları: görüntü kırpma aracı dijital dünyada birçok fayda sunar. Bazıları aşağıda açıklanmıştır:',
          tocLabel: '4. Görüntü Kırpmanın Faydaları',
          bullets: [
            'Görüntüyü çerçeveye sığdırma: Görüntü kırpıcı, görüntüyü çerçeveye doğru şekilde yerleştirmenize yardımcı olur. Bu çerçeve bir web sayfasında veya herhangi bir sosyal medya platformunda olabilir.',
            'UX iyileştirme: Görüntünün doğru yerleşimi kullanıcı deneyimini artırdığı için görüntü kırpıcı UX’i büyük ölçüde geliştirir.',
            'İstenmeyen kenarlıkları kaldırma: Görüntüyü iyileştirmek için istenmeyen kenarlıkları kaldırabilirsiniz.',
            'İstenen nesneyi ayırma: Grup fotoğrafından kendinizi de ayırabilirsiniz.',
            'Depolama tasarrufu: Görüntü kırpma depolama tasarrufu sağlar; çünkü görüntünün ham alanı kesilir ve yalnızca gerekli kısım kalır.',
            'Sunumları optimize etme: Kırpılmamış 10 görüntülü normal bir sunum yaklaşık 30MB depolama kullanırken, aynı sunum kırpılmış görüntülerle yaklaşık 10MB depolama kullanabilir.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Desteklenen formatlar:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Çevrimiçi Fotoğraf Editörü — Metin, Efektler, Çerçevelerle Ücretsiz Düzenle | photremium.com',
      desc: 'Fotoğrafları çevrimiçi ücretsiz düzenleyin — metin, efektler, çerçeveler, çıkartmalar ekleyin. Tarayıcıda çalışır.',
      keywords: 'fotoğraf editörü, çevrimiçi fotoğraf editörü, fotoğraf düzenle çevrimiçi ücretsiz',
    },
    title: 'Fotoğraf Editörü',
    desc: 'Fotoğraflarınızı metin, efektler, çerçeveler ve çıkartmalarla süsleyin.',
    toEdit: 'düzenlemek için',
    textTypography: 'Metin ve Tipografi',
    textTypographyDesc: 'Çeşitli yazı tipleri, renkler, gölgeler ve konum seçenekleriyle metin ekleyin.',
    filtersEffects: 'Filtreler ve Efektler',
    filtersEffectsDesc: 'Profesyonel filtreler uygulayın ve parlaklık, kontrast ile doygunluğu ayarlayın.',
    framesStickers: 'Çerçeveler ve Çıkartmalar',
    framesStickersDesc: 'Görüntünüzü geliştirmek için güzel çerçeveler ve eğlenceli çıkartmalar seçin.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Görüntü Arka Planını Ücretsiz Kaldır | photremium.com',
      uploadDesc: 'Görüntü arka planlarını yüksek doğrulukla hızla kaldırın. Ücretsiz çevrimiçi arka plan kaldırıcı.',
      uploadKeywords: 'arka plan kaldır, arka plan kaldırıcı, görüntü arka planını kaldır, şeffaf arka plan',
      workspaceTitle: 'Arka Plan Kaldırılıyor — photremium.com',
      workspaceDesc: 'Görüntü arka planını çevrimiçi ücretsiz kaldırın.',
      workspaceKeywords: 'arka plan kaldır, şeffaf arka plan',
    },
    title: 'Arka Planı Kaldır',
    desc: 'Gelişmiş kenar algılama ile görüntü arka planını anında kaldırın. %100 ücretsiz, tarayıcıda çalışır.',
    toRemoveBg: 'arka planı kaldırmak için',
    backgroundRemover: 'Arka Plan Kaldırıcı',
    processingProgress: 'İşleme İlerlemesi',
    processingNImages: '{n} görüntü işleniyor…',
    allNProcessed: 'Tüm {n} görüntü işlendi!',
    nOfTotalDone: '{n} / {total} tamamlandı',
    fileName: 'Dosya Adı',
    dimensions: 'Boyutlar',
    status: 'Durum',
    statusDone: '✓ Tamamlandı',
    statusProcessing: '⏳ İşleniyor',
    statusError: '✗ Hata',
    statusPending: '⏸ Bekliyor',
    badgeDone: 'Tamamlandı',
    badgeProcessing: 'İşleniyor…',
    badgeError: 'Hata',
    removingBg: 'Arka plan kaldırılıyor…',
    retry: 'Yeniden Dene',
    downloading: 'İndiriliyor…',
    nextImage: 'Sonraki Görüntü',
  },

  watermark: {
    seo: {
      uploadTitle: 'Görüntü Filigranı — Metin ve Logo Filigramı Ücretsiz Ekle | photremium.com',
      uploadDesc: 'Saniyeler içinde fotoğraflara metin veya görüntü filigranı ekleyin. Ücretsiz, hızlı.',
      uploadKeywords: 'görüntü filigranı, filigran ekle, metin filigranı',
      workspaceTitle: 'Görüntü Filigranı — photremium.com',
      workspaceDesc: 'Görüntülere çevrimiçi ücretsiz filigran ekleyin.',
      workspaceKeywords: 'görüntü filigranı, filigran ekle',
    },
    title: 'Görüntü Filigranı',
    desc: 'Görüntülere metin veya logo filigranı ekleyin. Yazı tipi, opaklık, boyut ve konumu özelleştirin.',
    toWatermark: 'filigran eklemek için',
    watermarkTools: 'Filigran Araçları',
    addText: 'Metin Ekle',
    addImage: 'Görüntü Ekle',
    layersN: 'Katmanlar ({n})',
    noLayers: 'Henüz katman eklenmedi',
    textLayer: 'Metin Katmanı',
    imageLayer: 'Görüntü Katmanı',
    watermarkDownloadAll: 'Filigranla ve Tümünü İndir',
    watermarkDownload: 'Filigranla ve İndir',
    nextImage: 'Sonraki Görüntü',
    bold: 'Kalın',
    italic: 'İtalik',
    underline: 'Altı Çizili',
    bgColor: 'Arka Plan Rengi',
    textColor: 'Metin Rengi',
    alignLeft: 'Sola Hizala',
    alignCenter: 'Ortaya Hizala',
    alignRight: 'Sağa Hizala',
    opacity: 'Opaklık',
    stroke: 'Kontur',
    strokeWidth: 'Kontur Genişliği',
    strokeColor: 'Kontur Rengi',
    tileRepeat: 'Döşeme/Tekrar',
    tilePattern: 'Döşeme Deseni',
    spacing: 'Aralık',
    snapToCenter: 'Merkeze Yapıştır',
    duplicate: 'Çoğalt',
    delete: 'Sil',
    flipHorizontal: 'Yatay Çevir',
    flipVertical: 'Dikey Çevir',
    rotateLeft: 'Sola Döndür',
    rotateRight: 'Sağa Döndür',
    cornerRadius: 'Köşe Yarıçapı',
    borderStroke: 'Kenarlık/Kontur',
    borderWidth: 'Kenarlık Genişliği',
    color: 'Renk',
    style: 'Stil',
    hide: 'Gizle',
    show: 'Göster',
    lock: 'Kilitle',
    unlock: 'Kilidi Aç',
    solid: 'Düz',
    dashed: 'Kesik',
    dotted: 'Noktalı',
    double: 'Çift',
    tileSingle: 'Tek',
    tile2x2: '2×2 Izgara',
    tile3x3: '3×3 Izgara',
    removeAllConfirm: 'Tüm görüntüleri ve filigranları kaldıracak mısınız?',
    dimMismatch: 'Yüklenen görüntülerin boyutları farklı. En iyi sonuç için aynı çözünürlükte görüntü yükleyin.',
    clearBackground: 'Arka Planı Temizle',
    typeHere: 'Buraya yazın...',
    linkCorners: 'Köşeleri Bağla',
    separateCorners: 'Köşeleri Ayır',
    blog: {
      tocTitle: 'İçindekiler',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Filigran Aracı Genel Bakış',
          title: 'Görsellerinize Çevrimiçi Olarak Filigran Ekleme — Photremium Filigran Aracının Tam Rehberi',
          paragraphs: [
            'Güzel bir fotoğrafı düzenlemeyi yeni bitirdiniz. Bu, mağazanız için bir ürün fotoğrafı olabilir, bir müşteri çekiminden alınmış portre olabilir ya da saatlerce kusursuzlaştırdığınız dijital bir çalışma olabilir. Ve şimdi her üreticinin sonunda karşılaştığı soru geliyor: paylaşmadan önce bunu nasıl korursunuz?',
            'Çoğu profesyonelin vardığı cevap filigrandır — ve bunun iyi bir nedeni var. Doğru yerleştirilmiş bir filigran, çalışmanız üzerinde kalıcı bir imza gibi davranır; eserinizi izlenebilir, markalı ve çalınması çok daha zor hale getirir.',
            'İnsanların sık karşılaştığı sorun şudur: çevrimiçi araçlar ya çok hantal olur, ya aboneliklerin arkasına kilitlenmiştir, ya da o kadar ağır bir filigran üretir ki görseli tamamen mahveder.',
            'Photremium’un Watermark Image aracı tüm bunları düzeltmek için tasarlandı. Bu, tamamen tarayıcı tabanlı, ücretsiz, hesap gerektirmeyen bir filigran çalışma alanıdır ve dosyalarınızı bir sunucuya yüklemeden doğrudan tarayıcınızda çalışır. Her şey yerel kalır, her şey hızlı kalır ve sunduğu yaratıcı kontrol seviyesi, masaüstü yazılımdan bekleyeceğiniz düzeyle yarışır. Bu rehberde, nasıl çalıştığını, kimler için tasarlandığını ve her seferinde en iyi sonuçları nasıl alacağınızı tam olarak göstereceğiz.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Filigran Nedir',
          title: 'Filigran Nedir ve Neden Önemlidir?',
          paragraphs: [
            'Aracın kendisine geçmeden önce, filigranın ne yaptığını ve neden birçok fotoğrafçı, tasarımcı ve içerik üreticisinin onu vazgeçilmez gördüğünü anlamak faydalıdır.',
            'Filigran, bir görsele eklenen görünür bir bindirmedir — genellikle metin, bir logo veya bir telif hakkı simgesi — ve içeriğin üreticisini ya da sahibini tanımlar. Dosyanın içinde gizli olan ve saniyeler içinde silinebilen meta verilerin aksine, filigran görselin kendisine görsel olarak gömülür. Üzerine sağ tıklayıp kaliteyi belirgin şekilde düşürmeden kaldırmanız mümkün değildir.',
          ],
          subSections: [
            {
              title: 'Üreticiler Neden Filigran Kullanır',
              paragraphs: [
                'Görsellerinize filigran eklemenin pratik nedenleri üç temel kaygıya dayanır.',
              ],
              bullets: [
                'Sahiplik tanımlaması. Çalışmanız sosyal medya platformlarında, Pinterest panolarında veya blog yazılarında paylaşıldığında orijinal atıf çoğu zaman kaybolur. Filigran, adınızın veya markanızın görsel nereye giderse gitsin onunla birlikte taşınmasını sağlar.',
                'Hırsızlığı caydırma. Çoğu sıradan görsel hırsızı en kolay yolu arar. Profesyonel görünen, özellikle iyi konumlandırılmış ve biraz şeffaf bir filigran açık bir mesaj verir: bu görsel, işine önem veren birine aittir.',
                'Müşteri portföyünü koruma. Nihai ödeme öncesinde müşterilere önizleme paylaşan fotoğrafçılar, müşterinin faturayı ödemeden önizlemeyi kullanmasını engellemek için sık sık filigran kullanır. İnce bir filigran bunu yaparken önizlemeyi gereğinden fazla dikkat dağıtıcı hale getirmez.',
              ],
            },
            {
              title: 'Kimler Görsellerini Filigranlamalı',
              paragraphs: [
                'Aşağıdaki kategorilerden herhangi birine giriyorsanız, görsellerinizi çevrimiçi paylaşmadan önce filigranlamak bir seçenek değil — zorunluluktur:',
              ],
              bullets: [
                'Müşterilerle galeri paylaşan serbest fotoğrafçılar',
                'Portföy örnekleri dağıtan grafik tasarımcılar',
                'Lisans anlaşmalarından önce ürün fotoğrafları gösteren e-ticaret satıcıları',
                'Çalışmalarını sosyal platformlarda paylaşan dijital sanatçılar',
                'Görselleri sık sık yeniden kullanılan blog yazarları ve içerik üreticileri',
                'Tanınabilir bir marka oluşturan stok fotoğraf katkıcıları',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Çalışma Alanı Panelleri',
          title: 'Photremium Filigran Aracının İçinde: Gerçek İş Akışları İçin Tasarlanmış Üç Panelli Çalışma Alanı',
          paragraphs: [
            'Photremium filigran aracını temel çevrimiçi filigran araçlarından ayıran şey çalışma alanı tasarımıdır. Basit bir “metni yaz, konumu seç, bitti” yaklaşımı yerine, profesyonel tasarım yazılımlarında bulacağınız yapıyı andıran üç panelli bir düzen sunar — tek fark, tamamen tarayıcıda çalışması ve kurulum gerektirmemesidir.',
          ],
          subSections: [
            {
              title: 'Sol Canvas Paneli',
              paragraphs: [
                'Canvas paneli ekranın en büyük bölümünü kaplar ve filigran uygulandığında görselinizin nasıl göründüğünü gerçek zamanlı olarak tam olarak gösterir. Yaptığınız her değişiklik — opaklığı ayarlama, bir metin katmanını yeniden konumlandırma, bir logoyu yeniden boyutlandırma — canvas üzerinde anında görünür. Tıklanacak bir “önizleme” düğmesi yoktur. Ne görüyorsanız onu alırsınız.',
                'Canvas ayrıca yerleşik bir yakınlaştırma araç çubuğu içerir; hassas hizalama için yakınlaştırıp genel görünüm için uzaklaştırabilirsiniz. Ekrana sığdırma özelliği, ekran boyutunuza göre en iyi başlangıç ölçeğini otomatik olarak hesaplar; böylece yüksek çözünürlüklü görseller bile rahat bir çalışma boyutunda açılır. Bir katmanı görselin yatay veya dikey merkezine yaklaştırdığınızda hizalama kılavuzları dinamik olarak görünür ve filigranı genellikle yalnızca Photoshop’ta alabileceğiniz türden tatmin edici bir hassasiyetle tam ortaya oturtur.',
              ],
            },
            {
              title: 'Sağ Ayar Paneli',
              paragraphs: [
                'Sağ panel kontrol merkezidir. Filigran katmanlarınızı burada yönetir, görünümlerini özelleştirir ve son dışa aktarımı başlatırsınız. Masaüstünde ekranın sağ tarafına sabitlenmiştir. Mobil cihazlarda ise alttan kayan bir alt panel olarak açılır — yüzen dişli düğmesiyle tetiklenir — böylece çalışırken canvas’ınızı asla kapatmaz.',
                'Sağ panelde, eklediğiniz tüm filigran öğelerini listeleyen katman yöneticisini bulacaksınız. Her katman girdisi katman türünü (metin veya görsel), mevcut adını ya da içeriğini ve üç hızlı eylem düğmesini gösterir: görünürlük anahtarı (göz simgesi), diğer katmanlarla çalışırken bir katmanın konumunu donduran kilit anahtarı ve silme düğmesi.',
              ],
            },
            {
              title: 'Sol Önizleme Şeridi (Çoklu Görsel Modu)',
              paragraphs: [
                'Aynı anda birden fazla görselle çalışırken — bir ürün fotoğrafı grubu ya da tam bir portre çekimi gibi — ekranın en solunda dikey bir küçük resim şeridi görünür. Bu, yüklediğiniz her dosyanın küçük önizlemelerini gösteren görsel kuyruğudur. Herhangi bir küçük resme tıklamak canvas’ınızı anında o görsele geçirir; böylece katman ayarlarınızı kaybetmeden filigranın farklı kompozisyonlarda nasıl göründüğünü kontrol edebilirsiniz.',
                'Şerit ayrıca her dosya için KB veya MB cinsinden boyut bilgisini ve dosya biçimi etiketini (JPG, PNG, WEBP) gösterir; böylece ne üzerinde çalıştığınızı bir bakışta bilirsiniz.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Adım Adım',
          title: 'Adım Adım: Photremium’da Görselinize Filigran Nasıl Eklenir',
          paragraphs: [
            'Bu anlatım, aracın kaput altında nasıl çalıştığına doğrudan dayanır — sürükle bırak yükleme sisteminden, indirme öncesinde filigranınızı görsele kalıcı olarak yazan canvas render motoruna kadar.',
          ],
          steps: [
            {
              heading: '1. Adım — Görselinizi Yükleyin',
              paragraphsBefore: [
                'photremium.com/watermark-image adresine gidin. Sayfanın ortasında temiz bir sürükle-bırak alanı bulunan yükleme ekranına ulaşırsınız.',
                'Görselinizi araca getirmenin üç yolu vardır:',
              ],
              bullets: [
                'Sürükle ve bırak. Masaüstünüzden bir veya daha fazla görsel dosyasını doğrudan bırakma alanına sürükleyin. Araç JPEG, PNG, WEBP ve daha fazlası gibi tüm standart görsel biçimlerini kabul eder. Dosyaları çalışma alanının üzerine sürüklediğinizde, tüm alanın etrafında mor bir çerçeve etkinleşir ve “Drop images to add for watermarking” görsel istemi görünür; böylece bırakmanın kaydedildiğini bilirsiniz.',
                'Tıklayarak göz atın. Sistem dosya seçicinizi açmak için bırakma alanının içindeki “Choose Files” düğmesine tıklayın. Windows’ta Ctrl+Click veya Mac’te Cmd+Click kullanarak aynı anda birden fazla dosya seçebilirsiniz.',
                'Panodan yapıştırın. Bir görseli panoya kopyaladıysanız — bir ekran görüntüsünden, başka bir uygulamadan veya bir web tarayıcısından — filigran sayfasındayken Ctrl+V’ye (Mac’te Cmd+V) basmanız yeterlidir ve görsel doğrudan çalışma alanına yüklenir. Bu, zaten birden fazla görsel yüklenmiş olsa bile çalışır.',
              ],
              paragraphsAfter: [
                'İlk görsel yüklendiğinde, çalışma alanı yükleme ekranından tam üç panelli düzenleyiciye geçer ve canvas, otomatik olarak hesaplanmış ekran uyumlu yakınlaştırma düzeyinde görselinizi gösterir.',
              ],
            },
            {
              heading: '2. Adım — Bir Metin Filigran Katmanı Ekleyin',
              paragraphsBefore: [
                'Sağ paneldeki mor “Add Text” düğmesine tıklayın. Canvas üzerinde yeni bir metin katmanı görünür ve varsayılan yer tutucu metin “Type here...” önceden seçili olur.',
                'Hemen yazmaya başlayabilirsiniz. Metin, canvas üzerinde beyaz Arial olarak, görselinizin boyutlarına göre ayarlanmış varsayılan bir ölçüyle canlı olarak render edilir. Metin katmanı seçili olduğunda görünen üst araç çubuğundan metnin her yönünü özelleştirebilirsiniz:',
              ],
              bullets: [
                'Yazı tipi ailesi — Arial, Georgia, Impact, Brush Script MT, Comic Sans MS ve daha fazlası dahil 12 yerleşik yazı tipinden seçin',
                'Yazı tipi boyutu — özel bir piksel değeri doğrudan yazın veya artırma kontrollerini kullanın',
                'Kalın, italik, altı çizili — bu stillerden istediğiniz kombinasyonu açın',
                'Metin rengi — renk örneğine tıklayıp renk seçiciyi açın ve herhangi bir hex renk seçin',
                'Arka plan rengi — metninizin arkasına renkli arka plan ekleyerek etiket veya rozet görünümü verin',
                'Kontur (çerçeve) — hem açık hem koyu görsellerde maksimum okunabilirlik için çizgi kalınlığı ve rengi belirleyin',
                'Opaklık — 0% (görünmez) ile 100% (tam opak) arasında ayarlayın; çoğu filigran %30 ile %60 arasındadır',
                'Hizalama — metni sınır kutusu içinde sola, ortaya veya sağa hizalayın',
                'Döndürme — metin katmanını herhangi bir açıya döndürün; 0°, 90°, 180° ve 270°’deki manyetik snap noktalarıyla hızlı düz konumlandırma yapın',
              ],
              paragraphsAfter: [
                'Metni taşımak için canvas üzerinde tıklayıp sürükleyin. Piksel hassasiyetinde ince konumlama için klavyedeki ok tuşlarını kullanın (10 piksel adımlar için Shift’e basılı tutun). Metin kutusunu yeniden boyutlandırmak için seçili katmanın etrafında görünen sekiz yeniden boyutlandırma tutamaçlarından (köşeler ve kenarlar) herhangi birini sürükleyin.',
              ],
            },
            {
              heading: '3. Adım — Bir Görsel (Logo) Filigran Katmanı Ekleyin',
              paragraphsBefore: [
                'Metin yerine ya da metne ek olarak bir logo, imza veya herhangi bir görseli filigran olarak kullanmak istiyorsanız, sağ paneldeki mavi “Add Image” düğmesine tıklayın. Dosya seçiciniz açılır ve cihazınızdaki filigran görsel dosyasını seçebilirsiniz.',
                'Araç, filigran görselini orijinal en-boy oranını koruyarak canvas genişliğinin yaklaşık %30’una otomatik olarak ölçeklendirir ve canvas üzerinde ortalar. Buradan sonra, onu herhangi bir konuma sürükleyebilir, köşe tutamaçlarını kullanarak yeniden boyutlandırabilir (en-boy oranı korunur) veya seçili katmanın üstünde beliren özel döndürme tutamacıyla döndürebilirsiniz.',
                'Görsel türündeki filigran katmanları için sağ panel ek kontroller sunar:',
              ],
              bullets: [
                'Opaklık — metin katmanlarıyla aynı, şeffaf PNG logolar için ideal',
                'Yatay çevir / Dikey çevir — gerekirse filigranı aynalayın',
                'Kenarlık genişliği, kenarlık rengi ve kenarlık stili — logo filigranın etrafına görünür bir çerçeve ekleyin',
                'Köşe yarıçapı — logo filigranın köşelerini tek tip olarak veya her köşe için ayrı kontrolle yuvarlayın',
                'Döndürme — metin katmanlarıyla aynı pürüzsüz döndürme davranışı',
              ],
            },
            {
              heading: '4. Adım — Döşemeyi Yapılandırın (İsteğe Bağlı)',
              paragraphsBefore: [
                'Aracın daha güçlü özelliklerinden biri döşemedir — filigranınızı tüm görsel boyunca bir ızgara düzeninde tekrar etme yeteneği. Bu, bir görseli yalnızca markalamak yerine yeniden yayınlamaya elverişsiz hale getirmek istediğinizde özellikle kullanışlıdır.',
                'Bir katman seçiliyken araç çubuğundaki tile seçeneğini bulun. Şunlara ayarlayabilirsiniz:',
              ],
              bullets: [
                'Yok — tek konumlandırma (varsayılan)',
                '2×2 Izgara — filigranı 2 sütun, 2 satır düzeninde tekrarlar',
                '3×3 Izgara — daha yoğun kapsama için 3×3 ızgarada tekrarlar',
              ],
              paragraphsAfter: [
                'Döşeme aralığını da ayarlayabilirsiniz; bu, her tekrar arasındaki mesafeyi kontrol eder. Canvas, tüm döşemeli kopyaların hayalet önizlemelerini gösterir, böylece indirmeden önce tam kapsama desenini görebilirsiniz.',
              ],
            },
            {
              heading: '5. Adım — Birden Fazla Filigran için Katman Yöneticisini Kullanın',
              paragraphsBefore: [
                'İstediğiniz kadar katman ekleyebilirsiniz — metin ve görsel filigranları özgürce karıştırabilirsiniz. Sağ paneldeki katman yöneticisi hepsini listeler. Yapabilecekleriniz:',
              ],
              bullets: [
                'Göz simgesini kullanarak tek tek katmanları göster/gizle — hiçbir şeyi silmeden farklı filigran sürümleri arasında geçiş yapmak için kullanışlı',
                'Diğer katmanlar üzerinde çalışırken yanlışlıkla yer değiştirmesini önlemek için bir katmanı kilitle',
                'Bir katmanı kalıcı olarak sil',
              ],
              paragraphsAfter: [
                'Listedeki herhangi bir katman girdisine tıklamak, onu aynı anda canvas üzerinde de seçer; böylece görsel üzerinde aramak zorunda kalmadan katmanlar arasında geçiş yapmak kolaylaşır.',
              ],
            },
            {
              heading: '6. Adım — Birden Fazla Görsel Arasında Geçiş Yapın',
              paragraphsBefore: [
                'Birden fazla görsel yüklediyseniz, soldaki küçük resim şeridini kullanarak aktif canvas görselinizi değiştirin. Yapılandırdığınız filigran katmanları evrensel olarak uygulanır — dışa aktarırken toplu işleminizdeki her görsel üzerine render edilirler.',
                'Araç ayrıca toplu işleminizde çözünürlük tutarlılığı kontrolü yapar. Görsellerinizin boyutları belirgin biçimde farklıysa (genişlik veya yükseklikte %5’ten fazla fark varsa), filigran konumunun görseller arasında boyut farkı nedeniyle farklı görünebileceğini belirten bir uyarı çıkar. Motor bunu orantılı yeniden konumlandırma algoritmasıyla zarif biçimde ele alır: filigran konumunu referans görselin boyutlarının yüzdesi olarak hesaplar ve aynı orantılı konumu topludaki diğer tüm görsellere uygular; böylece farklı çözünürlüklerde bile görsel niyet korunur.',
              ],
            },
            {
              heading: '7. Adım — İndirme Tercihlerinizi Ayarlayın',
              paragraphsBefore: [
                'Tek görsellik işler için, filigranlı görseli doğrudan kaydetmek üzere canvasın altındaki “Download” düğmesine tıklayın. Dosya adı otomatik olarak orijinal dosya adınıza uzantıdan önce “-watermarked” eklenmiş şekilde ayarlanır. JPEG görselleri 0.95 kaliteyle dışa aktarılır — normal görüntü boyutlarında orijinalden ayırt edilemeyecek kadar yüksektir. PNG görselleri kayıpsız PNG olarak dışa aktarılır.',
                'Toplu işler için (birden fazla görsel) sağ panelde seçebileceğiniz iki indirme modu vardır:',
              ],
              bullets: [
                'ZIP dosyası — tüm filigranlı görseller tek bir ZIP arşivinde paketlenir ve tek tıklamayla indirilir. Araç sıkıştırma için JSZip’i dinamik olarak yükler.',
                'Ayrı dosyalar — her görsel ayrı bir dosya olarak indirilir; tarayıcı kısıtlamalarını önlemek için her indirme arasında kısa bir gecikme olur.',
              ],
            },
            {
              heading: '8. Adım — İndirin ve Doğrulayın',
              paragraphsBefore: [
                'İndirme düğmesine (veya toplu işlemler için “Watermark & Download All” düğmesine) tıkladıktan sonra araç, her görseli gizli bir HTML5 canvas öğesi üzerinde tam yerel çözünürlükte render eder — ekranda gördüğünüz ölçeklenmiş önizleme boyutunda değil. Bu, dışa aktarılan görselin orijinal piksel boyutlarının %100’ünde olduğu ve filigranın orantısal olarak doğru boyutta çizildiği anlamına gelir. İndirilen dosyayı açın ve yakınlaştırarak filigran konumunun ve kalitesinin beklentinizle uyumlu olduğunu doğrulayın.',
                'Bir şey ters görünüyorsa, çalışma alanına geri dönün — katmanlarınız hâlâ orada olacak — ayarlayın ve tekrar indirin.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Profesyonel ipuçları',
          title: 'En iyi sonuçlar için profesyonel ipuçları',
          bullets: [
            'En profesyonel görünüm için yarı saydam bir PNG logo kullanın. Şeffaf arka planlı ve %40–50 opaklıktaki bir logo filigranı, düz metinden çok daha şık görünür. Görsel katman olarak kullanmadan önce logonuzu tasarım aracınızdan alfa şeffaflıklı PNG olarak dışa aktarın.',
            'Filigranınızı kırpıldığında değerini yok edecek bir yere yerleştirin. Sağ alt köşe en yaygın filigran konumudur — ve kırpılması en kolay olanıdır. Daha güçlü koruma için, filigranınızı yüz, bir ürün detayı veya odak noktası gibi görsel açıdan önemli bir alanın üzerine yerleştirmeyi düşünün. Çapraz döşeme seçeneğini kaldırmak, görsele belirgin zarar vermeden çok daha zordur.',
            'Birden fazla katmanla çalışırken kilit özelliğini kullanın. Ana filigran konumundan memnun kaldığınızda, ikincil katmanları eklemeden önce o katmanı kilitleyin. Bu, diğer öğeler üzerinde çalışırken yanlışlıkla oynatmanızı önler.',
            'Görselinizin açık ve koyu alanlarında test edin. Beyaz bir filigran parlak gökyüzünde görünmezken, koyu bir gölgede rahatça okunur. Filigranın altındaki içerik ne olursa olsun okunabilirlik için ince bir stroke veya arka plan rengi ekleyin.',
            'Klavye kısayolları her zaman zaman kazandırır. Ok tuşları seçili katmanı birer piksel hareket ettirir. Shift+Ok, onar piksel hareket ettirir. Delete tuşu seçili katmanı anında kaldırır. Bu kısayollar, konumu ince ayarlamayı sürüklemekten çok daha hızlı hale getirir.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Gizlilik ve güvenlik',
          title: 'Gizlilik ve güvenlik: tarayıcı tabanlı işlemenin neden önemli olduğu',
          paragraphs: [
            'Çevrimiçi araçları kullanırken birçok üreticinin en büyük kaygılarından biri, görsellerinin gerçekte nereye gittiğidir. Sunucu tabanlı filigran araçlarında görseliniz sağlayıcının sunucusuna yüklenir, orada işlenir ve ardından size geri gönderilir. Bu da yayımlanmamış çalışmalarınızın, müşteri fotoğraflarınızın veya hassas ürün görsellerinizin başka birinin altyapısından geçmesi anlamına gelir.',
            'Photremium’un filigran aracı her şeyi tarayıcınızda yerel olarak işler. Görselleriniz tarayıcının File API’si kullanılarak cihazınızın belleğine yüklenir ve internet üzerinden asla aktarılmaz. Filigran oluşturma, JavaScript içinde çalışan bir HTML5 canvas öğesi üzerinde, tamamen tarayıcı sekmenizin içinde gerçekleşir. Sayfayı kapattığınızda veya “Start Over” düğmesine bastığınızda tüm görsel verileri bellektan çıkarılır ve atılır. Kendi cihazınızın dışında hiçbir yerde saklanmaz.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Son özet',
          title: 'Photremium filigran aracının neden düzenli iş akışınızda yer almayı hak ettiği',
          paragraphs: [
            'Çevrimiçi olarak onlarca filigran aracı var. Bir aracı yer imlerine eklemeye değer kılan ile unutulmaya değer kılan şey genellikle hız, kontrol ve güvenilirliğin birleşimidir.',
            'Hız önemlidir çünkü filigran ekleme işlemi, son iş akışınıza ciddi zaman eklememelidir. Photremium aracı anında yüklenir, yerel olarak işler ve büyük toplu işler için bile saniyeler içinde tam çözünürlükte dışa aktarır. Sunucu tarafı işlem bekleme süresi, kuyruk yoktur ve aynı anda çevrimiçi kullanıcı sayısıyla artan bir render süresi yoktur.',
            'Kontrol önemlidir çünkü yanlış görünen bir filigran, hiç filigran olmamasından daha kötüdür — markanızı profesyonel olmayan gösterir. Katman sistemi, araç çubuğundaki öğe bazlı kontroller, gerçek zamanlı canvas önizlemesi ve klavye kısayolu desteği, özel masaüstü yazılımlarla gerçekten kıyaslanabilir bir kontrol seviyesi sunar.',
            'Güvenilirlik önemlidir çünkü yayımlanmamış işleriniz değerlidir. Görsellerinizin internet üzerinden üçüncü taraf bir sunucuya hiç gitmediğini bilmek, müşteri fotoğraflarını, henüz piyasaya çıkmamış ürün görsellerini ve hassas yaratıcı çalışmaları veri işleme, sunucu tarafı ihlaller veya bulut sağlayıcılarının politika değişiklikleri konusunda endişe etmeden filigranlayabileceğiniz anlamına gelir.',
            'İster tek bir fotoğrafa hızlı bir telif bildirimi ekliyor olun ister bir müşteri galerisi paylaşmadan önce 200 görsellik tüm çekimi işliyor olun, Photremium’un Watermark Image aracı bunu doğru şekilde yapmanız için size gereken araçları sağlar — tamamen ücretsiz, tamamen gizli ve filigranın görselin üstüne yapıştırılmış değil de görselin parçasıymış gibi görünmesi için yeterli yaratıcı esneklikle.',
            'photremium.com/watermark-image adresine gidin ve deneyin. İlk filigranlı görseliniz gerçekten sadece otuz saniye uzakta.',
            'Photremium, tarayıcı tabanlı görüntü düzenleme ve işleme araçlarından oluşan bir set sunar. Tüm araçlar tarayıcınızda yerel olarak çalışır — görselleriniz cihazınızda kalır.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'QR Kod Oluşturucu — Ücretsiz Oluştur ve Özelleştir | photremium.com',
      inputDesc: 'URL, metin, WiFi, kişiler, e-posta ve Google Maps için özel QR kodları oluşturun.',
      inputKeywords: 'qr kod oluşturucu, qr kod yap, özel qr kod',
      customizeTitle: 'QR Kodu Özelleştir — photremium.com',
      customizeDesc: 'QR kodunuzun stilini, renklerini, çerçevesini ve logosunu özelleştirin. PNG, JPG, SVG, WEBP veya PDF olarak indirin.',
      customizeKeywords: 'qr kod özelleştir, qr kod stili',
    },
    title: 'QR Kod Oluşturucu',
    desc: 'URL, metin, WiFi, kişiler, e-posta ve haritalar için QR kodları oluşturun, özelleştirin ve indirin.',
    generate: 'Oluştur',
    scanQrCode: 'QR Kodu Tara',
    tabUrl: 'Bağlantı / URL',
    tabText: 'Metin',
    tabWifi: 'WiFi',
    tabContact: 'Kişiler',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'URL girin',
    enterText: 'Metin girin',
    networkName: 'Ağ Adı (SSID)',
    password: 'Şifre',
    encryption: 'Şifreleme',
    hiddenNetwork: 'Gizli Ağ',
    contactName: 'Kişi Adı (isteğe bağlı)',
    phoneNumber: 'Telefon Numarası',
    emailAddress: 'E-posta Adresi',
    subject: 'Konu (isteğe bağlı)',
    body: 'İçerik (isteğe bağlı)',
    searchLocation: 'Konum ara',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Metninizi buraya yazın…',
    wifiNamePlaceholder: 'WiFi\'m',
    passwordPlaceholder: 'şifre',
    contactPlaceholder: 'Ahmet Yılmaz',
    phonePlaceholder: '+90 555 123 4567',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'konu',
    bodyPlaceholder: 'e-posta içeriği…',
    locationPlaceholder: 'Şehir, adres, yer ara…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Yok',
    characters: 'karakter',
    generateCustomize: 'Oluştur ve Özelleştir',
    editQrData: 'QR Verisini Düzenle',
    styleShape: 'Stil ve Şekil',
    colorTab: 'Renkler',
    framesTab: 'Çerçeveler',
    logoTab: 'Logo',
    templatesTab: 'Şablonlar',
    fileFormatTab: 'Dosya Formatı',
    fgColor: 'Ön Plan Rengi',
    bgColor: 'Arka Plan Rengi',
    enableGradient: 'Gradyanı Etkinleştir',
    gradientType: 'Gradyan Türü',
    linear: 'Doğrusal',
    radial: 'Radyal',
    selectFrame: 'Çerçeve Seç',
    selectLogo: 'Logo Seç',
    uploadCustomLogo: 'veya özel logo yükle',
    uploadImage: 'Görüntü Yükle',
    downloadFormat: 'İndirme Formatı',
    preview: 'Önizleme',
    downloadFormatBtn: '{format} İndir',
    pngDesc: 'Kayıpsız, şeffaflık desteği',
    jpgDesc: 'Popüler/evrensel dosya formatı',
    webpDesc: 'Modern format, en iyi kalite/boyut',
    svgDesc: 'Ölçeklenebilir vektör grafik',
    pdfDesc: 'Yazdırmaya hazır belge',
    lat: 'Enlem:',
    lng: 'Boylam:',
    qrCode: 'QR Kod',
    scanMe: 'Tara',
    scanHere: 'Buradan Tara',
    blog: {
      card1: {
        title: '1. QR Kod Nedir?',
        intro1: 'QR kodunun tam biçimi "Quick Response code" (Hızlı Yanıt kodu) anlamına gelir. İçinde saklanan bilgiler çok hızlı şekilde çözüldüğü için Quick Response (QR) kodu olarak adlandırılır.',
        intro2: 'QR kodu, yalnızca makineler tarafından okunabilen iki boyutlu bir dijital koddur. İçindeki veriler insan tarafından okunamaz. Metin, iletişim numaraları, bağlantılar ve Google Harita konumları vb. gibi bilgileri depolamak için bloklar içerir.',
        inventionTitle: 'QR Kod Nasıl İcat Edildi:',
        inventionText: 'QR kod 1994 yılında icat edilmiştir. Masahiro Hara ve ekibi, Toyota için otomobil parçaları üreten Denso Wave adlı bir Japon şirketinde çalışıyordu. Sıradan bir barkoddan çok daha fazla bilgi depolayan bir kod istiyorlardı ve böylece QR kodunu icat ettiler.',
        keyFeaturesTitle: 'QR Kodun Temel Özellikleri',
        keyFeatures: [
          {
            title: 'QR Nasıl Çalışır',
            text: 'QR kodu oluşturmak için metni veya bağlantıyı girersiniz. QR oluşturucu bilgiye göre kare kutular oluşturur. Her kutu bir biti temsil eder ve her bit bir karakteri depolar.',
          },
          {
            title: 'QR Kodunun Yapısı',
            text: 'QR kodu, QR kodunun yönünü belirlemek için üç büyük kare kutu ve bitleri (bilgileri) depolamak için bir küçük kare kutu içerir.',
          },
          {
            title: 'QR Kodunun Veri Kapasitesi',
            text: 'Tipik olarak, QR kodu barkoddan daha fazla bilgi depolar. QR kodu basitçe barkodun geliştirilmiş bir sürümüdür. Temelde iki boyutlu bir barkodtur. QR kodu neredeyse 200 karakteri depolar. 400 karakteri de depolayabilir ancak taranması zor olabilir. 400 karakterden fazlasını depolamak, neredeyse tarananamayacak kadar karmaşık bir QR kodu oluşturabilir.',
          },
          {
            title: 'QR Kodlarında Hata Algılama',
            text: 'QR kodu, bazı bilgileri kazıırsa veya bazı bitler ters çevrilirse yine de taranaabilir. QR kodu hataları algılamak ve tanımlamadan sonra çözmek için Reed-Solomon hata algılama tekniğini kullanır.',
          },
        ],
        errorTitle: 'QR Kodunun Hata Düzeltme Düzeyi:',
        errorIntro: 'Çeşitli hata algılama ve düzeltme teknikleri aşağıda açıklandığı gibi farklı durumlar da kullanılır:',
        errorHeaders: {
          level: 'Seviye',
          recovery: 'İyileştirme kapasitesi',
          bestUse: 'En iyi kullanım durumu',
        },
        errorRows: [
          {
            level: 'Düşük (L)',
            recovery: '~7%',
            useCases: [
              'Bu hata düzeltme tekniği, QR kodu dijital ekranlarda, web sitelerinde veya temiz bir ortamda görüntülendiğinde kullanılır.',
              'QR kodu Gmail, iletişim numarası veya küçük metin gibi küçük bilgiler için oluşturulduğunda.',
            ],
          },
          {
            level: 'Orta (M)',
            recovery: '~15%',
            useCases: [
              'Temiz bir ortama kurulu broşür ve posterler için ve hasar riski ihmal edilebilir olduğunda.',
            ],
          },
          {
            level: 'Çeyrek (Q)',
            recovery: '~25%',
            useCases: [
              'QR kodunun fabrika/açık alan gibi sert ortamda kurulması gerektiğinde.',
              'Ayrıca, ortada küçük bir logo gerektiğinde, bazı bitleri kapsar. Bu nedenle bu hata düzeltme tekniği gereklidir.',
            ],
          },
          {
            level: 'Yüksek (H)',
            recovery: '~30%',
            useCases: [
              'QR koduna ağır hasar ihtimali olduğunda kullanılır.',
              'Büyük logolar QR kodunun merkezini kapattığında.',
              'Ayrıca QR koduna ağır stil gerektiğinde.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Neden QR Kod Oluşturucumuzu Seçmelisiniz?',
        intro: 'QR kod oluşturucumuz QR kod oluşturmayı son derece hızlı, güvenli ve kolay hale getirir. Kodunuzu daha gelişmiş, profesyonel ve iş temanızla eşleşecek şekilde özelleştirebilirsiniz. QR kodunu renklendirmekten QR koduna logo kurulumuna kadar tüm özelleştirmeler sonsuza dek ücretsiz olarak sunulur.',
        strengths: [
          {
            title: 'Profesyonel Özelleştirme:',
            text: 'İhtiyacınız kadar çok QR kodu herhangi bir maliyet olmaksızın oluşturabilir ve özelleştirebilirsiniz. Tüm özellikler tamamen ücretsizdir. Renk degradeleri, kare kutular için farklı şekiller, özel logolar ve diğer birçok özelliği uygulayabilirsiniz.',
          },
          {
            title: 'Çoklu Format Desteği:',
            text: 'QR kod oluşturucumuz sizin rahatlığınız için birden fazla indirme formatı sunar. İndirmeden önce tercih ettiğiniz formatı seçmeniz yeterlidir. Şu anda bu formatları sunuyoruz:',
          },
          {
            title: 'Önceden Yapılmış Şablonlar:',
            text: 'QR kodunuzu profesyonel hale getiren önceden yapılmış renk degradeleri ve çerçeveleri kullanabilirsiniz.',
          },
          {
            title: 'Özel Logo Desteği:',
            text: 'Ayrıca QR kodunun merkezine otomatik olarak uyan özel marka logonuzu yükleyebilirsiniz. 30\'dan fazla logonun sağlandığı yerleşik logo kitaplığından logo seçebilirsiniz.',
          },
          {
            title: 'Canlı Önizleme:',
            text: 'Özelleştirirken canlı önizleme panelinde tüm değişiklikleri izleyebilirsiniz. Önizleme panelindeki bu değişiklikler gerçek zamanlı ve dinamik olarak değişir.',
          },
          {
            title: 'Tarama Göstergesi:',
            text: 'Renk seçerken, taranması zor olan renkleri seçerseniz uygun uyarılar ve göstergeler sizi rehberlik eder.',
          },
        ],
        formatHeaders: {
          srNo: 'Sıra No',
          formats: 'Formatlar',
          description: 'Açıklama',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Kayıpsız, şeffaflık desteği' },
          { no: '2', format: 'JPG', description: 'Popüler, evrensel dosya formatı' },
          { no: '3', format: 'WEBP', description: 'Modern, en iyi kalite/boyut' },
          { no: '4', format: 'SVG', description: 'Ölçeklenebilir vektör grafik' },
          { no: '5', format: 'PDF', description: 'Yazdırmaya hazır belge' },
        ],
      },
      card3: {
        title: '3. Adım Adım Kılavuz:',
        step1Intro: 'Her şeyden önce, oluşturmak istediğiniz QR kodunun kategorisini seçin. İster kişi, harita, bağlantı veya metin için QR kodu oluşturun. Şu anda QR kod oluşturucumuz şu kategorileri sunmaktadır:',
        categories: ['Bağlantı / URL', 'Metin', 'WiFi', 'Kişi', 'Gmail', 'Google Maps'],
        step2: 'Kategoriyi seçtikten sonra bilgilerinizi metin kutusuna yapıştırın.',
        step3Intro: 'Ardından, özelleştirme panelini açmak için "Oluştur ve Özelleştir" düğmesini tıklayın. Özelleştirme panelinde aşağıdaki seçeneklere sahip bir alt gezinti çubuğu göreceksiniz:',
        options: [
          {
            title: 'Stil ve Şekil:',
            text: 'Bu bölümde kare kutuların şekillerini yuvarlak köşeler, noktalar, yatay çubuklar, dikey çubuklar, küçük kareler ve diğer birçok stil gibi değiştirebilirsiniz.',
          },
          {
            title: 'Renk:',
            text: 'Bu bölümde özel arka plan ve ön plan renkleri seçebilirsiniz. QR kodunuzu renk degradelerine dönüştürmek için, yerleşik kitaplıktan herhangi bir renk degradesini uygulayabilir veya kolayca kendi renk degradesini oluşturabilecek bir seçeneğiniz vardır. Doğrusal renk degradesi açısını da değiştirebilirsiniz. Radyal renk gradesi de desteklenir. Profesyonel bir renk degradesi efekti oluşturmak için birden fazla renk ekleyebilirsiniz.',
          },
          {
            title: 'Çerçeveler:',
            text: 'Burada QR kodunuz için mükemmel bir çerçeve seçebilirsiniz. Tüm çerçeveler otomatik olarak kodunuzla uyum sağlar. Yerleşik kitaplıktan bir çerçeve seçmeniz yeterlidir.',
          },
          {
            title: 'Logo:',
            text: 'Çerçeve seçiminden sonra QR kodunun merkezine otomatik olarak ayarlanan bir logo seçebilirsiniz. Özel marka logonuzu yükleme de desteklenmektedir.',
          },
          {
            title: 'Şablonlar:',
            text: 'Stil, şekil, renk ve çerçeveyi ayrı ayrı seçmek istemiyorsanız, QR kodunuza önceden yapılmış şablonları uygulayabilirsiniz. Sizes kolaylık için ücretsiz olan birden fazla premium şablon mevcuttur.',
          },
          {
            title: 'Dosya Biçimi:',
            text: 'Sonunda, QR kodunu indirmek istediğiniz dosya türünü seçmeniz gerekir. PNG, WEBP, SVG ve PDF gibi birkaç ortak format desteklenir.',
          },
          {
            title: 'QR Verilerini Düzenle:',
            text: 'Ayrıca seçilen özelleştirmelerinizde herhangi bir kayıp olmaksızın QR verilerinizi düzenleyebilirsiniz.',
          },
        ],
        finalStep: 'Ardından indirme düğmesini tıklayın ve QR kodu tam özelleştirmelerinize göre seçilen biçimde anında herhangi bir maliyet olmaksızın indirilecektir.',
      },
      card4: {
        title: '4. Yararlar:',
        intro: 'QR kodu, fiziksel dünyayı dijital deneyimle bağlantı kurar. Bağlantıları, kişileri veya konumunuzu paylaşmanın en hızlı yoludur. QR kodunu taramanız yeterlidir ve bilgiye anında erişir. Bu nedenle zaman açısından verimli ve çok amaçlı olduğu için operasyon ve dijital dünyada çok popülerdir.',
        benefits: [
          {
            title: 'Ömür Boyu Destek:',
            text: 'QR kodları son kullanma tarihi olmaksızın sonsuza dek çalışır. Taradıktan sonra size depolanan bilgileri anında sağlar. Kodlanmış dijital talimatları depolar yolunda, asla bilgisini kaybetmez.',
          },
          {
            title: 'Çevrimdışı Destek:',
            text: 'Çevrimdışı olsanız bile QR kodunu tarayabilirsiniz. Mobil kameranız QR kodunun desenlerini kodu çözer ve size içinde depolanan bilgileri verir.',
          },
          {
            title: 'Sıfır Maliyet:',
            text: 'Bu kodlar herhangi bir sunucu yönlendirmesi veya kaynağı gerektirmediğinden sonsuza dek ücretsizdir.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'QR Kod Tarayıcı — Kamera veya Görüntüden QR Kodu Tara | photremium.com',
      desc: 'Kamera veya görüntü yükleyerek QR kodlarını anında tarayın. URL, metin, WiFi, kişiler ve diğerlerini algılayın.',
      keywords: 'qr kod tarayıcı, qr kod tara, qr okuyucu, çevrimiçi qr kod',
    },
    title: 'QR Kod Tarayıcı',
    desc: 'Kamera veya görüntü yükleyerek QR kodlarını anında tarayın. Hızlı ve güvenli.',
    generateQrCode: 'QR Kod Oluştur',
    scan: 'Tara',
    cameraScanner: 'Kamera Tarayıcı',
    uploadImage: 'Görüntü Yükle',
    pointCamera: 'Kamerayı QR koda yöneltin',
    startCamera: 'Kamerayı Başlat',
    loading: 'Yükleniyor…',
    dropQrImage: 'QR kod görüntüsünü buraya bırakın',
    toScan: 'taramak için',
    supportedFormats: 'JPG, PNG, GIF, WEBP desteklenir',
    ctrlVPaste: 'Ctrl+V ile yapıştır',
    scanFromGallery: 'Galeriden Tara',
    instantScanning: 'Anında Tarama',
    instantScanningDesc: 'Kameradan veya yüklenen görsellerden gerçek zamanlı QR kod algılama',
    private100: '%100 Gizli',
    private100Desc: 'Tüm işlemler tarayıcınızda gerçekleşir. Hiçbir şey yüklenmez',
    multiFormat: 'Çoklu Format',
    multiFormatDesc: 'URL, metin, WiFi, kişi, e-posta, telefon ve daha fazlasını algılar',
    accessingCamera: 'Kameraya erişiliyor…',
    cameraDenied: 'Kamera erişimi reddedildi. Lütfen kamera iznine izin verin ve tekrar deneyin.',
    noCamera: 'Bu cihazda kamera bulunamadı.',
    cameraError: 'Kameraya erişilemiyor. Lütfen tekrar deneyin.',
    videoError: 'Video oynatma başlatılamadı.',
    switchError: 'Kamera değiştirilemedi.',
    tryAgain: 'Tekrar Dene',
    switchCamera: 'Kamera Değiştir',
    stop: 'Durdur',
    noQrFound: 'QR Kod Bulunamadı',
    couldNotRead: 'Görüntü okunamadı',
    scannerFailed: 'Tarayıcı yüklenemedi',
    noQrFoundDesc: 'Görüntüde QR kodu algılanamadı. Başka bir görüntü deneyin veya kamera tarayıcıyı kullanın.',
    qrScanned: 'QR Kod Tarandı!',
    openLink: 'Bağlantıyı Aç',
    copied: 'Kopyalandı!',
    copy: 'Kopyala',
    share: 'Paylaş',
    scanAgain: 'Tekrar Tara',
    network: 'Ağ',
    password: 'Şifre',
    security: 'Güvenlik',
    unknown: 'Bilinmiyor',
    typeText: 'Metin',
    typeUrl: 'URL',
    typeWifi: 'WiFi Ağı',
    typeContact: 'Kişi Kartı',
    typeEmail: 'E-posta',
    typePhone: 'Telefon Numarası',
    typeSms: 'SMS',
    typeLocation: 'Konum',
    blog: {
      tocTitle: 'İçindekiler',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Neden QR kod tarayıcı kullanmalısınız?',
          paragraphs: [
            'QR kod tarayıcı, temel olarak QR kodunda saklanan bilgileri çözen bir mobil kameradır. Kamerayı QR koda yöneltmeniz yeterlidir; QR kodun yönü ne olursa olsun belirli desenleri okur, hataları algılar, gerekirse düzeltir ve içindeki bilgiyi gösterir.',
          ],
          listTitle: 'QR kod tarayıcı türleri:',
          bullets: [
            'Web Tabanlı QR kod tarayıcı: Tarayıcınızın desteklediği çevrim içi tarayıcılarla QR kod tarayabilirsiniz. Bilgiye kamera üzerinden veya görsel yükleyerek ulaşabilirsiniz. Otomatik yönlendirme ve diğer gelişmiş özellikler için https://photremium.com adresini ziyaret edebilirsiniz.',
            'Mobil kameralar: Bazı modern telefonlarda kendi kamera uygulamalarında yerleşik QR kod tarayıcı bulunur. Bunlar, QR kodu normal kamerayla tarayarak bilgiyi alıp çözebilir.',
            'Uygulamalar: QR kod taramak için özel geliştirilmiş bazı uygulamalar vardır. Ancak gelişmiş yönlendirme ve birçok özellik için uygulamayı bu bağlantıdan ücretsiz kurabilirsiniz: https://photremium.com.',
            'Donanım cihazları: QR kod taramak için bazı donanım cihazları da üretilmiştir. Bu cihazlar büyük alışveriş merkezlerinde ürün faturalandırmasında yaygın olarak kullanılır.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Neden bizim QR kod tarayıcımızı seçmelisiniz?',
          paragraphs: [
            'QR koddan çözümlenen içeriği kopyalamaya kadar yönlendirme dahil birçok gelişmiş özelliği keşfedebilirsiniz. QR kod tarayıcımızdaki diğer ilgi çekici özellikler şunlardır:',
          ],
          bullets: [
            'Yüksek Hız: QR kod tarayıcımız, QR kod çözümlemeyi son derece hızlı hale getirir. QR kodu taramanız yeterlidir; aracımız size bilgiyi anında verir ve metin/bağlantıyı kopyalama, bağlantı algılanırsa açma veya kişi algılanırsa otomatik kaydetme gibi gelişmiş seçenekler sunar.',
            'Kurulum Gerekmez: QR kod tarayıcımıza erişmek için ayrı bir uygulama kurmanız gerekmez. Bu araca yerel tarayıcınızdan ücretsiz erişebilirsiniz.',
            'Platformlar Arası Erişim: Herhangi bir cihazda erişebilirsiniz. İşletim sistemi sürümü veya başka bir gereksinim konusunda endişe etmeyin. Tüm sürümler ve tüm cihazlarda desteklenir.',
            'Tüm Formatlar Desteklenir: Düz metin, WiFi, URL, kişi, Gmail ve Google Haritalar vb. dahil QR kodda saklanabilen tüm veri formatları aracımız tarafından desteklenir.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Adım adım rehber:',
          steps: [
            {
              heading: '1. Öncelikle QR kodu taramak için bir yöntem seçin. Bunu yapmak için aşağıdaki iki yöntem vardır:',
              subSteps: [
                {
                  heading: 'i. Kamera yöntemi',
                  paragraphs: [
                    'Basit bir kamerayı destekleyen dizüstü bilgisayar, PC veya herhangi bir cihaz kullanıyor olsanız bile cihaz kameranızla QR kod tarayabilirsiniz. “Start Camera” düğmesine tıklayınca bir izin isteği açılır; bu sitenin QR tarama için kameranızı kullanmasına izin verin. Yanlışlıkla reddettiyseniz veya izin isteği görünmüyorsa aşağıdaki adımlarla kameraya manuel erişim verebilirsiniz:',
                  ],
                  notes: [
                    '➔ Chrome için (Android / Masaüstü):',
                    '1. Üç noktaya tıklayın',
                    '2. Settings bölümüne gidin',
                    '3. (Android için bu adımı atlayın) Privacy and Security',
                    '4. Site Settings\'e tıklayın',
                    '5. Ardından permissions bölümünde Camera\'ya tıklayın',
                    '6. Sitemizin URL\'sini bulun: https://photremium.com/qr-code-scanner',
                    '7. Açılır menüden kameraya izin verin.',
                    '➔ Safari için (iPhone / iOS):',
                    '1. Adres çubuğundaki AA veya Website Settings simgesine dokunun.',
                    '2. Website Settings\'i seçin.',
                    '3. Camera\'ya dokunun ve Allow seçin.',
                    '4. Hâlâ engelliyse: iPhone Settings > Safari > Camera yoluna gidin ve Ask veya Allow olarak ayarlayın.',
                  ],
                },
                {
                  heading: 'ii. Galeri yöntemi',
                  paragraphs: [
                    'Bilgilere erişmek için QR kod görseli yükleyebilirsiniz. “Scan from Gallery” düğmesine tıklayın, dosya gezgini açılır. Ardından QR kod görselini seçin. jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz ve .xbm vb. tüm görsel formatları desteklenir.',
                  ],
                },
              ],
            },
            {
              heading: '2. QR kodu seçtiğinizde tüm bilgiler görüntülenir; algılanırsa kopyalamanıza, paylaşmanıza veya bağlantıyı açmanıza olanak tanır. İsterseniz tekrar tarayabilirsiniz.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'QR kod tarayıcının faydaları:.',
          paragraphs: [
            'QR kod tarayıcı bu dijital dünyada birçok fayda sunar. Ödeme, doğrulama ve bilgiye erişimi çevrim dışı modda bile kolay ve hızlı hale getirir.',
          ],
          bullets: [
            'Bilgiye anında erişim: QR kodu taramak bilgiyi milisaniyeler içinde sağlar. Desenleri çözer, hataları algılar ve çok hızlı şekilde giderir; kullanıcıya son derece hızlı bir deneyim sunar.',
            'Kesintisiz İletişim: Bu gelişim çağında banka bilgileri ve ürün detayları gibi küçük bilgiler için hızlı ve güvenli iletişim büyük önem taşır. QR kod tarayıcı bu sorunu çözer çünkü ödemeler QR kod taranarak yapılır. Ayrıca Google, dizüstünde yeni hesap oluştururken telefonu QR ile doğrular.',
            'E-Biletler: Otobüs terminallerinde, tren istasyonlarında veya havaalanlarında uzun kuyruklarda sıranızı beklemeden biletlerinizi kolayca doğrulayabilirsiniz. Ayrıca bekleme kuyruklarını azaltmak için havaalanlarının birçok noktasına QR kod tarayıcılar kurulur. Bu, çalışan ihtiyacını da azaltır ve böylece havayolu bütçesini otomatik olarak tasarruf ettirir.',
            'Ürün Doğrulama: Gelişmiş ve üst segment markalar ürünlerine QR kod yerleştirir. Müşteri bu QR kodu tarayarak ürünün orijinal olup olmadığını kontrol edebilir.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Yüz Bulanıklaştırma Aracı — Görüntülerdeki Yüzleri Çevrimiçi Bulanıklaştır | photremium.com',
      uploadDesc: 'AI yüz algılama ile görüntülerdeki yüzleri otomatik olarak bulanıklaştırın. Bulanıklık yoğunluğunu, şeklini veya emojiyi seçin.',
      uploadKeywords: 'yüz bulanıklaştır, yüzü bulanıklaştır, yüz algılama, gizlilik aracı',
      workspaceTitle: 'Yüz Bulanıklaştırma Aracı — photremium.com',
      workspaceDesc: 'Görüntülerdeki yüzleri otomatik olarak bulanıklaştırın. %100 ücretsiz.',
      workspaceKeywords: 'yüz bulanıklaştır, yüz algılama',
    },
    title: 'Yüz Bulanıklaştırma',
    desc: 'Gizlilik için görüntülerdeki yüzleri otomatik olarak algılayın ve bulanıklaştırın.',
    toBlurFaces: 'yüzleri bulanıklaştırmak için',
    autoDetection: 'Otomatik Algılama',
    autoDetectionDesc: 'AI yüz algılama tüm yüzleri anında bulur',
    customBlur: 'Özel Bulanıklaştırma',
    customBlurDesc: 'Bulanıklık yoğunluğunu, şeklini ve stilini ayarlayın',
    private100: '%100 Özel',
    private100Desc: 'Tüm işlemler tarayıcınızda yerel olarak gerçekleşir',
    blurTools: 'Bulanıklaştırma Araçları',
    faces: 'Yüzler',
    faceDetection: 'Yüz Algılama',
    detecting: 'Algılanıyor...',
    autoDetectFaces: 'Yüzleri Otomatik Algıla',
    exitManualMode: 'Manuel Moddan Çık',
    manualSelect: 'Manuel Seçim',
    nFaceRegions: '{n} yüz bölgesi bulundu',
    noFacesDetected: 'Yüz algılanmadı — manuel mod kullanın',
    manualHint: 'Bulanıklaştırılacak alanın üzerine dikdörtgen çizmek için tıklayın ve sürükleyin.',
    blurType: 'Bulanıklık Türü',
    blur: 'Bulanıklaştır',
    emoji: 'Emoji',
    blurIntensity: 'Bulanıklık Yoğunluğu',
    strength: 'Güç',
    blurShape: 'Bulanıklık Şekli',
    rectangle: 'Dikdörtgen',
    ellipse: 'Elips',
    circle: 'Daire',
    chooseEmoji: 'Emoji Seç',
    blurRegionsN: 'Bulanıklık Bölgeleri ({n})',
    faceN: 'Yüz {n}',
    manualRegionN: 'Manuel Bölge {n}',
    manualN: 'Manuel {n}',
    clearAllRegions: 'Tüm Bölgeleri Temizle',
    processingDots: 'İşleniyor...',
    downloadBlurred: 'Bulanık Görüntüyü İndir',
    downloadNImages: '{n} Görüntüyü İndir',
    downloadDialogTitle: 'Tüm Görüntüler Düzenlenmedi',
    downloadDialogText: '{total} görüntüden {edited} tanesini düzenlediniz.',
    downloadAll: 'Tümünü İndir',
    removeRegion: 'Bölgeyi Kaldır',
    region: 'Bölge',
    notAllEdited: 'Tüm Görüntüler Düzenlenmedi',
    editedXofY: '{total} görüntüden {edited} tanesini düzenlediniz.',
    nextImage: 'Sonraki Görüntü',
  },

  faqData: {
    imageConverter: [
      { q: 'Dönüştürme için hangi görüntü formatları destekleniyor?', a: 'JPG, PNG, WEBP, SVG, GIF, BMP, ICO ve TIFF\'i destekliyoruz. Bu formatlar arasında tarayıcınızda anında dönüştürebilirsiniz.' },
      { q: 'Dönüştürme sırasında görüntü kalitesi etkileniyor mu?', a: 'PNG gibi kayıpsız formatlar için kalite tamamen korunur. JPG ve WEBP gibi kayıplı formatlar için optimize edilmiş kodlama ayarları kullanırız.' },
      { q: 'Dosya boyutu veya miktar sınırı var mı?', a: 'Kesin sınır yok. Birden fazla görüntüyü aynı anda yükleyebilir ve toplu dönüştürebilirsiniz.' },
      { q: 'Verilerim güvende mi? Görüntüler sunucuya yükleniyor mu?', a: 'Kesinlikle. Tüm işlemler tarayıcınızda gerçekleşir. Görüntüleriniz asla cihazınızdan ayrılmaz.' },
      { q: 'Şeffaf PNG görüntüsünü JPG\'ye dönüştürebilir miyim?', a: 'Evet. JPG şeffaflığı desteklemediğinden, şeffaf alanlar varsayılan olarak beyaz arka planla doldurulur.' },
    ],
    imageCompressor: [
      { q: 'Görüntüyü sıkıştırmak kaliteyi düşürür mü?', a: 'Hayır, önerilen sınırların dışına çıkmadığınız sürece sıkıştırma görüntü kalitesini belirgin şekilde düşürmez. Kaliteyi göstergelerden takip edebilirsiniz: i. %1 ile %40 sıkıştırma: “İyi kalite” mesajıyla yeşil gösterge. ii. %41 ile %60 sıkıştırma: “Normal kalite” mesajıyla sarı gösterge. Bu aralık genellikle en çok önerilir. iii. %61 ile %100 sıkıştırma: sistem kırmızı “Kötü kalite” uyarısı verir ve kalite kaybı gözle fark edilebilir hale gelebilir.' },
      { q: 'Sıkıştırma için hangi görüntü formatları destekleniyor?', a: 'Görüntü sıkıştırma aracımız aşağıdaki tüm formatları destekler:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Aynı anda birden fazla görüntü sıkıştırabilir miyim?', a: 'Evet, kesinlikle. Sisteminiz desteklediği sürece birden fazla görüntüyü (hatta 100+) aynı anda sıkıştırabilirsiniz. Sıkıştırma işlemi cihaz kaynaklarını kullandığı için yüksek performanslı laptop, PC veya telefonlarda daha iyi sonuç alırsınız. Düşük donanımlı cihazlarda ise toplu işlemi partiler halinde yapabilirsiniz; araç bu şekilde kullanımda da ücretsizdir.' },
      { q: 'Görüntülerimizi sunucularınıza yüklüyor veya saklıyor musunuz?', a: 'Hayır, görüntülerinizi sunucularımıza ne yüklüyor ne de saklıyoruz. Tüm sıkıştırma işlemleri tarayıcınızda yerel olarak yapılır. Görüntüleriniz cihazınızdan asla ayrılmaz; bu nedenle kişisel veya özel görüntüleri güvenle sıkıştırabilirsiniz.' },
      { q: 'Bu görüntü sıkıştırma aracı ücretsiz mi?', a: 'Evet, görüntü sıkıştırma aracımız tamamen ve kalıcı olarak ücretsizdir. Sizden asla ödeme talep etmeyiz. Gizli ücret yoktur. Çoklu görüntü sıkıştırma dahil tüm özellikler ücretsizdir.' },
    ],
    cropImage: [
      { q: 'Görüntü kırpma kaliteyi düşürür mü?', a: 'Hayır, görüntü kırpma görüntünün görsel kalitesini hiç etkilemez. Kırpma yalnızca istenmeyen kısmı kaldırır. Kırpıldıktan sonra kalan bölümün piksellerini asla değiştirmez. Bu yüzden görüntülerinizi hiçbir piksel bozulması olmadan orijinal kalitede kırpabilirsiniz.' },
      { q: 'Görüntü kırpıcı hangi görüntü formatlarını destekliyor?', a: 'Görüntü kırpma aracımız neredeyse tüm görüntü formatlarını sunduğu için görüntünüzü herhangi bir formatta seçebilirsiniz. Aşağıda listelenmiştir:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Görüntülerim sunucunuza yükleniyor mu?', a: 'Hayır, tüm işlem yerel tarayıcınızda yapılır. Görüntüleriniz cihazınızdan hiç ayrılmadığı için sunucumuza asla yüklenmez. Bu nedenle kişisel görüntülerinizi görüntü kırpıcımızla hiçbir risk olmadan kırpabilirsiniz.' },
      { q: 'Aynı anda birden fazla görüntü kırpabilir miyim?', a: 'Evet, sisteminiz destekliyorsa aynı anda birden fazla görüntüyü (hatta 100+) kırpabilirsiniz. Görüntü kırpma sistem kaynaklarını kullandığı için yüksek performanslı bir laptop, PC veya telefonunuz varsa çok sayıda görüntüyü aynı anda kırpabilirsiniz. Düşük donanımlı bir cihazınız varsa görüntüleri partiler halinde kırpabilirsiniz; çünkü bu araç çok sayıda görüntüyü aynı anda kırpsanız bile ücretsizdir.' },
      { q: 'Bu görüntü kırpma aracı ücretsiz mi?', a: 'Evet, bu görüntü kırpma aracı tamamen ve kalıcı olarak ücretsizdir. Her yerde, her zaman ve herhangi bir cihazda erişebilirsiniz. Tüm cihazlar için duyarlı tasarım deneyimi sunar ve sizden hiçbir premium özellik için ödeme istenmez. Tüm özellikler gizli ücret olmadan tamamen ücretsizdir.' },
    ],
    resizeImage: [
      { q: 'Aynı anda birden fazla görüntüyü yeniden boyutlandırabilir miyim?', a: 'Kesinlikle. Aracımız aynı anda çoklu görüntü boyutlandırmayı destekler. Cihazınızın kaldırdığı kadar görüntü yükleyebilir ve AI motoruyla hepsini birlikte işleyebilirsiniz. Düşük donanımlı cihazlarda gecikmeyi önlemek için partiler halinde çalışmanız önerilir. Tüm işlem yerelde yapılır, sunucuya yükleme olmaz; gizlilik korunur.' },
      { q: 'Bu görüntü boyutlandırma aracı ücretsiz mi?', a: 'Evet, bu araç tamamen ve kalıcı olarak ücretsizdir. Premium özellikler için ücretli abonelik gerekmez. Boyutlandırılmış görüntüleri indirirken de gizli ücret yoktur.' },
      { q: 'Görüntüyü yeniden boyutlandırmak kaliteyi düşürür mü?', a: '✅Decrease Size (downscale): Görüntü boyutunu küçültmek görsel kaliteyi düşürmez. Hatta bazı durumlarda küçültülen görüntü daha keskin görünebilir. Bu nedenle daha küçük boyuta indirme genelde kalite kaybına neden olmaz.\n❌Increase Size (upscale): Görüntüyü orijinalden büyük yapmak görsel kaliteyi etkileyebilir. Ne kadar çok büyütürseniz kalite kaybı olasılığı o kadar artar.' },
      { q: 'Bu araç güvenli mi?', a: 'Evet, aracımız özellikle kişisel ve hassas görüntüler için güvenlidir. Tüm işlem cihazınızda yerel olarak gerçekleşir ve hiçbir veri cihazı terk etmez. Böylece gizlilik riski olmadan boyutlandırma yapabilirsiniz.' },
      { q: 'Hangi görüntü formatları destekleniyor?', a: 'Görüntü boyutlandırma aracımız tüm görüntü formatlarını destekler. Aşağıdaki formatlarda görüntü seçebilirsiniz:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Arka plan kaldırma nasıl çalışır?', a: 'Tarayıcıda doğrudan çalışan gelişmiş AI modellerini kullanarak konuyu algılar ve arka plandan ayırırız.' },
      { q: 'Karmaşık arka planlar için çalışıyor mu?', a: 'Evet. AI modeli çeşitli sahneleri işler. Konu ve arka plan arasında net bir kontrast olduğunda en iyi sonuçlar elde edilir.' },
      { q: 'Birden fazla görüntüden aynı anda arka plan kaldırabilir miyim?', a: 'Evet. Birden fazla görüntü yükleyin, araç bunları sırayla işler.' },
      { q: 'Çıktı formatı nedir?', a: 'Çıktı her zaman şeffaf arka planlı bir PNG dosyasıdır.' },
      { q: 'Görüntülerim sunucuya gönderiliyor mu?', a: 'Hayır. AI modeli WebAssembly kullanılarak tamamen tarayıcıda çalışır.' },
    ],
    watermarkImage: [
      { q: '1. Photremium filigran aracı ücretsiz mi?', a: 'Evet — photremium.com/watermark-image adresindeki araç ücretsizdir ve hesap veya abonelik gerektirmez. Tek tek resimlere veya toplu halde filigran uygulayabilirsiniz.' },
      { q: '2. Aynı anda kaç görüntü işleyebilirim?', a: 'Araç toplu işlemleri destekler. Bir klasörü sürükleyip bırakabilir veya çoklu dosya seçebilirsiniz; pratik sınır cihaz hafızası ile belirlenir.' },
      { q: '3. Hangi resim formatları desteklenir?', a: 'Tarayıcı File API tarafından işlenebilen formatlar desteklenir: JPEG, JPG, PNG, WEBP, GIF (statik), BMP ve SVG. Çıkış formatı giriş formatıyla eşleşir.' },
      { q: '4. Farklı çözünürlüklere sahip görüntülerde filigran aynı görünür mü?', a: 'Evet. Oransal yeniden konumlandırma motoru, referans görüntüdeki konumu hesaplayıp aynı oransal ofseti her hedef görüntüye uygulayarak görünümü korur.' },
      { q: '5. Kendi logomu metin yerine kullanabilir miyim?', a: 'Evet. Sağ paneldeki "Add Image" düğmesi, şeffaf arka plana sahip bir PNG yüklemenize izin verir; bu, katman olarak kullanılabilir.' },
      { q: '6. Filigranı yarı saydam nasıl yaparım?', a: 'Kanvasta filigran katmanını seçin ve opaklık kaydırıcısını ayarlayın. %30–50 genellikle profesyonel ve nazik bir görünüm verir.' },
      { q: '7. Tek bir görselde birden fazla filigran katmanı olabilir mi?', a: 'Evet. Katman sistemi sınırsız katmanı destekler; her biri ayrı ayarlanabilir.' },
      { q: '8. Tiling özelliği ne yapar ve ne zaman kullanılmalı?', a: 'Tiling, filigranı resim boyunca ızgara halinde tekrarlar; izinsiz kullanımın önlenmesi gereken durumlar için uygundur.' },
      { q: '9. Araç mobilde çalışıyor mu?', a: 'Evet — arayüz duyarlıdır; küçük ekranlarda düzen üst üste gelir ve kontroller dokunmaya uygundur.' },
      { q: '10. Görsellerim gizli mi ve sunucuya gönderiliyor mu?', a: 'Hayır — görseller cihazınızdan çıkmaz. Tüm işlem tarayıcıda Canvas API kullanılarak yerel olarak yapılır; veri yüklemesi yoktur.' },
    ],
    qrCodeGenerator: [
      { q: 'Bu QR kodu sona erer mi?', a: 'Hayır, bu QR kodları sona ermez ve ömür boyu destek garantisindedir. Kare kutular içinde bit şeklinde kodlanmış talimatları sakladığı için, bunlarda saklanan bilgiler değiştirilemez veya silinir. Kod bilgilerine, hatta yıllar sonra bile herhangi bir kamerayla tarayarak erişebilirsiniz.' },
      { q: 'QR kodum neden taranmıyor?', a: 'QR kodunuz şu nedenlerden dolayı taranmayabilir: i. Düşük Kontrast: Benzer arka plan ve ön plan renkleri seçerseniz, QR kodunun görünürlüğünü etkiler ve tarama hatasına neden olur. Ancak aracımız, özelleştirme sırasında düşük kontras veya diğer taramayla ilgili herhangi bir sorun hakkında sizi yönlendirir. ii. Büyük Veriler: Çok büyük metin veya veriler için bir QR kodu oluşturursanız, çok karmaşık hale gelir ve tarama sırasında sorun görür. Metin uzunluğu doğrulayıcı, QR kodu oluşturma sırasında optimal metin uzunluğu hakkında sizi yönlendirir. iii. Bulanık Baskı: QR kodunuzu PNG veya SVG gibi yüksek çözünürlüklü bir biçimde indirdiğinizden emin olun, bu zaten aracımız tarafından desteklenmektedir.' },
      { q: 'QR koduna logo ekleyebilir miyim?', a: 'Elbette, QR kodunuza özel bir logo ekleyebilir veya yerleşik logo kitaplığından birini seçebilirsiniz. Seçtiğiniz logo, QR kodunun merkezine otomatik olarak ayarlanacaktır.' },
      { q: 'QR kodunu nasıl tarayabilirim?', a: 'QR kodunu mobil kameranızı kullanarak tarayabilirsiniz. Ancak bağlantıya otomatik yönlendirme ve diğer birçok ileri özellik için, QR kodu tarayıcımızı https://photremium.com/qr-code-scanner bağlantısını kullanarak ücretsiz olarak ziyaret edebilirsiniz.' },
      { q: 'Ücretsiz olarak kaç QR kodu oluşturabilirim?', a: 'SINIRSIZ! Ücretsiz olarak birden fazla QR kodu oluşturabilirsiniz. Tüm özellikler, özelleştirmeler ve şablonlar herkese sonsuza kadar ücretsiz. Premium özelliklerinden yararlanmak için abonelik gerekli değildir.' },
      { q: 'QR kodu oluşturmak için giriş yapması veya kaydolması gerekli midir?', a: 'Hayır, metninizi girin, QR kodu oluşturun ve özelleştirmeden sonra indirin. Tüm özellikler tamamen ücretsiz olarak erişilebildiğinden giriş yapmanıza veya kaydolmanıza gerek yoktur.' },
    ],
    qrCodeScanner: [
      { q: 'Kayıtlı görsellerden ve ekran görüntülerinden QR kod tarayabilir miyim?', a: '**Evet**, kayıtlı görsellerden veya ekran görüntülerinden QR kod tarayabilirsiniz. QR kod tarayıcımız https://photremium.com/qr-code-scanner galeriden QR kod taramanıza olanak tanır. Sadece görseli seçmeniz yeterli ve o QR koddan çözümlenen tüm bilgilere ulaşırsınız.' },
      { q: 'QR kod tarayıcı için Uygulama yüklemem gerekir mi?', a: '**Hayır**, web tabanlı QR kod tarayıcımız herhangi bir uygulama yüklemeye gerek kalmadan QR kod taramanızı sağlar. Gelişmiş QR kod tarayıcımıza tüm cihazlarda ücretsiz erişebilirsiniz.' },
      { q: 'Tarayıcı neden QR kodu tanımıyor?', a: 'QR kodunuz aşağıdaki nedenlerden biri nedeniyle taranmıyor olabilir: i. Yetersiz ışık: QR kodu loş ışıkta taramak sorun çıkarabilir. Herhangi bir ekrandan tarıyorsanız feneri açın ve parlaklığı artırın. ii. Mesafe: Uygun olmayan mesafeden taramak da sorunlara neden olur. QR kod taramak için ideal mesafe yaklaşık 10 inçtir (25cm). iii. Kirli kamera lensi: Kamera lensleri kirliyse QR kod da taranamayabilir. Taramadan önce lensleri temizleyin. “Tarayıcıda bir kutu ızgarası görüyor musunuz? Başarılı tarama için QR kodu bunun içine yerleştirin.”' },
      { q: 'Bu araç ters veya renkli bir QR kodu tarar mı?', a: '**Evet**, QR kodunu herhangi bir renk veya yönde tarayabilirsiniz. Ancak arka plan ve ön plan renk kontrastı düşükse taramada zorluk yaşanabilir.' },
      { q: 'Bu aracın kullanımı ücretsiz mi?', a: '**Evet**, bu araç tamamen ücretsizdir. Sınırsız QR kodu sonsuza kadar ücretsiz tarayabilirsiniz.' },
    ],
    faceBlur: [
      { q: 'Yüz algılama nasıl çalışır?', a: 'AI destekli yüz algılama modeli doğrudan tarayıcınızda çalışır. Görüntülerdeki yüzleri tanımlar.' },
      { q: 'Bulanıklaştırmak istediğim yüzleri seçebilir miyim?', a: 'Evet. Algılamadan sonra her yüz bölgesi vurgulanır ve bulanıklaştırmak istediğiniz yüzleri seçebilirsiniz.' },
      { q: 'Hangi bulanıklık stilleri mevcut?', a: 'Gauss bulanıklığı, pikselleştirme veya düz renk kaplama arasından seçebilir ve yoğunluğu ayarlayabilirsiniz.' },
      { q: 'Birden fazla görüntüdeki yüzleri aynı anda bulanıklaştırabilir miyim?', a: 'Evet. Birden fazla görüntü yükleyin, bulanıklık bölgelerini yapılandırın, ardından tüm işlenmiş görüntüleri indirin.' },
      { q: 'Fotoğraflarım uzak sunucuya gönderiliyor mu?', a: 'Hayır. AI modeli WebAssembly kullanılarak tarayıcınızda çalışır.' },
    ],
    photoEditor: [
      { q: 'Hangi düzenleme özellikleri mevcut?', a: 'Parlaklık, kontrast, doygunluk ayarları, filtre uygulama, metin, katman, çerçeve ve çıkartma ekleme — hepsi tarayıcı içinde.' },
      { q: 'Değişiklikleri geri alıp yeniden yapabilir miyim?', a: 'Evet. Editör tam geri al/yeniden yap geçmişini destekler.' },
      { q: 'Hangi dosya formatları düzenlenip dışa aktarılabilir?', a: 'JPG, PNG, WEBP ve diğer yaygın formatları düzenleyebilirsiniz.' },
      { q: 'Editör telefonda çalışıyor mu?', a: 'Evet. Editör tamamen duyarlı ve dokunmatik ekrana uyumludur.' },
      { q: 'Görüntülerim sunucuda depolanıyor mu?', a: 'Hayır. Tüm düzenleme işlemleri yerel olarak gerçekleşir.' },
    ],
  },
};

export default tr;
